//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { ClientBase } from './client-base';
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, from as _observableFrom, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class HealthcheckClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Endpoint for checking if Vitech service is alive.
     * @return OK
     */
    alive(): Observable<FlagsApiResponseOfBoolean> {
        let url_ = this.baseUrl + "/v1/healthcheck/alive";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processAlive(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processAlive(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FlagsApiResponseOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FlagsApiResponseOfBoolean>;
        }));
    }

    protected processAlive(response: HttpResponseBase): Observable<FlagsApiResponseOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FlagsApiResponseOfBoolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * An endpoint that returns a cookie for authentication.
     * @return OK
     */
    groupexists(): Observable<FlagsApiResponseOfBoolean> {
        let url_ = this.baseUrl + "/v1/healthcheck/groupexists";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGroupexists(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGroupexists(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FlagsApiResponseOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FlagsApiResponseOfBoolean>;
        }));
    }

    protected processGroupexists(response: HttpResponseBase): Observable<FlagsApiResponseOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FlagsApiResponseOfBoolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FormsClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets all forms information for a policy.
     * @param selectedState (optional) The selected state from UI.
     * @return OK
     */
    allForms(selectedState?: string | undefined): Observable<ApiResponseOfAllFormsResponse> {
        let url_ = this.baseUrl + "/v1/forms/allForms?";
        if (selectedState === null)
            throw new Error("The parameter 'selectedState' cannot be null.");
        else if (selectedState !== undefined)
            url_ += "selectedState=" + encodeURIComponent("" + selectedState) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processAllForms(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processAllForms(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfAllFormsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfAllFormsResponse>;
        }));
    }

    protected processAllForms(response: HttpResponseBase): Observable<ApiResponseOfAllFormsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfAllFormsResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets overview information for a policy.
     * @param body (optional) EOI Application filters to retrieve EOI Application details.
     * @return OK
     */
    eoireport(body?: EOIApplicationsRequest | undefined): Observable<ApiResponseOfEOIApplicationsReponse> {
        let url_ = this.baseUrl + "/v1/forms/eoireport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processEoireport(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processEoireport(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfEOIApplicationsReponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfEOIApplicationsReponse>;
        }));
    }

    protected processEoireport(response: HttpResponseBase): Observable<ApiResponseOfEOIApplicationsReponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfEOIApplicationsReponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets schedule A letters for a policy.
     * @param body (optional) request filters to retrieve scheduleA letters.
     * @return OK
     */
    scheduleALetter(body?: ScheduleALetterSearchRequest | undefined): Observable<ApiResponseOfScheduleALetterSearchResponse> {
        let url_ = this.baseUrl + "/v1/forms/scheduleALetter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processScheduleALetter(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processScheduleALetter(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfScheduleALetterSearchResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfScheduleALetterSearchResponse>;
        }));
    }

    protected processScheduleALetter(response: HttpResponseBase): Observable<ApiResponseOfScheduleALetterSearchResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfScheduleALetterSearchResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Request ScheduleA letters.
     * @param body (optional) The ScheduleA letter request.
     * @return OK
     */
    requestScheduleALetter(body?: ScheduleAEmailServiceInput | undefined): Observable<ApiResponseOfBoolean> {
        let url_ = this.baseUrl + "/v1/forms/requestScheduleALetter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processRequestScheduleALetter(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processRequestScheduleALetter(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfBoolean>;
        }));
    }

    protected processRequestScheduleALetter(response: HttpResponseBase): Observable<ApiResponseOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfBoolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BillingsClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Searches for billing that on a policy that match the provided filter criteria.
     * @param body (optional) The billing search request.
     * @return OK
     */
    search(body?: BillingSearchRequest | undefined): Observable<FlagsApiResponseOfBillingSearchResponse> {
        let url_ = this.baseUrl + "/v1/billings/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processSearch(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSearch(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FlagsApiResponseOfBillingSearchResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FlagsApiResponseOfBillingSearchResponse>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<FlagsApiResponseOfBillingSearchResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FlagsApiResponseOfBillingSearchResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ClaimsClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets initiate claim flag.
     * @param body (optional) The claim to submit from UI.
     * @return OK
     */
    absenceflag(body?: ClaimSubmission | undefined): Observable<ApiResponseOfBoolean> {
        let url_ = this.baseUrl + "/v1/claims/absenceflag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processAbsenceflag(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processAbsenceflag(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfBoolean>;
        }));
    }

    protected processAbsenceflag(response: HttpResponseBase): Observable<ApiResponseOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfBoolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets Claimant Policies.
     * @param body (optional) The request from UI.
     * @return OK
     */
    claimantpolicies(body?: ClaimantPoliciesRequest | undefined): Observable<ApiResponseOfArrayOfString> {
        let url_ = this.baseUrl + "/v1/claims/claimantpolicies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processClaimantpolicies(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processClaimantpolicies(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfArrayOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfArrayOfString>;
        }));
    }

    protected processClaimantpolicies(response: HttpResponseBase): Observable<ApiResponseOfArrayOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfArrayOfString;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets Claim Detail.
     * @param body (optional) The request from UI.
     * @return OK
     */
    claimdetail(body?: ClaimDetailRequest | undefined): Observable<ApiResponseOfClaimDetailsResponse> {
        let url_ = this.baseUrl + "/v1/claims/claimdetail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processClaimdetail(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processClaimdetail(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfClaimDetailsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfClaimDetailsResponse>;
        }));
    }

    protected processClaimdetail(response: HttpResponseBase): Observable<ApiResponseOfClaimDetailsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfClaimDetailsResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets Claim List.
     * @param body (optional) The request from UI.
     * @return OK
     */
    claimslist(body?: ClaimsListRequest | undefined): Observable<ApiResponseOfClaimsListResponse> {
        let url_ = this.baseUrl + "/v1/claims/claimslist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processClaimslist(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processClaimslist(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfClaimsListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfClaimsListResponse>;
        }));
    }

    protected processClaimslist(response: HttpResponseBase): Observable<ApiResponseOfClaimsListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfClaimsListResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets Claim Loss Units.
     * @return OK
     */
    claimlossunit(): Observable<ApiResponseOfCluSearchResponse> {
        let url_ = this.baseUrl + "/v1/claims/claimlossunit";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processClaimlossunit(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processClaimlossunit(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfCluSearchResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfCluSearchResponse>;
        }));
    }

    protected processClaimlossunit(response: HttpResponseBase): Observable<ApiResponseOfCluSearchResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfCluSearchResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets custom claims report. In Go, this service is not in use anymore.
     * @param body (optional) The report selector from UI.
     * @return OK
     */
    customclaimsreport(body?: CustomClaimsReportSelector | undefined): Observable<ApiResponseOfArrayOfCustomClaimsReportInfo> {
        let url_ = this.baseUrl + "/v1/claims/customclaimsreport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCustomclaimsreport(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCustomclaimsreport(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfArrayOfCustomClaimsReportInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfArrayOfCustomClaimsReportInfo>;
        }));
    }

    protected processCustomclaimsreport(response: HttpResponseBase): Observable<ApiResponseOfArrayOfCustomClaimsReportInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfArrayOfCustomClaimsReportInfo;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets Employee Claim List.
     * @param social (optional) The social security number from UI.
     * @return OK
     */
    employeeclaimlist(social?: string | undefined): Observable<ApiResponseOfArrayOfClaimInfo> {
        let url_ = this.baseUrl + "/v1/claims/employeeclaimlist?";
        if (social === null)
            throw new Error("The parameter 'social' cannot be null.");
        else if (social !== undefined)
            url_ += "social=" + encodeURIComponent("" + social) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processEmployeeclaimlist(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processEmployeeclaimlist(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfArrayOfClaimInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfArrayOfClaimInfo>;
        }));
    }

    protected processEmployeeclaimlist(response: HttpResponseBase): Observable<ApiResponseOfArrayOfClaimInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfArrayOfClaimInfo;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets Location List.
     * @return OK
     */
    locationlist(): Observable<ApiResponseOfArrayOfString> {
        let url_ = this.baseUrl + "/v1/claims/locationlist";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processLocationlist(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processLocationlist(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfArrayOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfArrayOfString>;
        }));
    }

    protected processLocationlist(response: HttpResponseBase): Observable<ApiResponseOfArrayOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfArrayOfString;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets Policy's Claims Flags.
     * @param policyNumber (optional) The policy number from UI.
     * @return OK
     */
    policyclaimsflags(policyNumber?: string | undefined): Observable<ApiResponseOfPolicyClaimsFlagsResponse> {
        let url_ = this.baseUrl + "/v1/claims/policyclaimsflags?";
        if (policyNumber === null)
            throw new Error("The parameter 'policyNumber' cannot be null.");
        else if (policyNumber !== undefined)
            url_ += "policyNumber=" + encodeURIComponent("" + policyNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPolicyclaimsflags(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPolicyclaimsflags(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfPolicyClaimsFlagsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfPolicyClaimsFlagsResponse>;
        }));
    }

    protected processPolicyclaimsflags(response: HttpResponseBase): Observable<ApiResponseOfPolicyClaimsFlagsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfPolicyClaimsFlagsResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Search for claim data based on policy number(s).
     * @param body (optional) The search claim request.
     * @return OK
     */
    searchClaim(body?: SearchClaimRequest | undefined): Observable<ApiResponseOfSearchClaimResponse> {
        let url_ = this.baseUrl + "/v1/claims/search-claim";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processSearchClaim(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSearchClaim(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfSearchClaimResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfSearchClaimResponse>;
        }));
    }

    protected processSearchClaim(response: HttpResponseBase): Observable<ApiResponseOfSearchClaimResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfSearchClaimResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ContactClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets Sym employee info.
     * @param userName (optional) The username to retrieve info.
     * @return OK
     */
    symcontacts(userName?: string | undefined): Observable<ApiResponseOfSymetraEmployeeContactResponse> {
        let url_ = this.baseUrl + "/v1/Contact/symcontacts?";
        if (userName === null)
            throw new Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined)
            url_ += "userName=" + encodeURIComponent("" + userName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processSymcontacts(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSymcontacts(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfSymetraEmployeeContactResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfSymetraEmployeeContactResponse>;
        }));
    }

    protected processSymcontacts(response: HttpResponseBase): Observable<ApiResponseOfSymetraEmployeeContactResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfSymetraEmployeeContactResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PolicyClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets coverage information for a policy.
     * @return OK
     */
    coverage(): Observable<ApiResponseOfPolicyCoveragesResponse> {
        let url_ = this.baseUrl + "/v1/policy/coverage";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCoverage(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCoverage(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfPolicyCoveragesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfPolicyCoveragesResponse>;
        }));
    }

    protected processCoverage(response: HttpResponseBase): Observable<ApiResponseOfPolicyCoveragesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfPolicyCoveragesResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets overview information for a policy.
     * @return OK
     */
    overview(): Observable<FlagsApiResponseOfPolicyOverviewResponse> {
        let url_ = this.baseUrl + "/v1/policy/overview";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processOverview(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processOverview(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FlagsApiResponseOfPolicyOverviewResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FlagsApiResponseOfPolicyOverviewResponse>;
        }));
    }

    protected processOverview(response: HttpResponseBase): Observable<FlagsApiResponseOfPolicyOverviewResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FlagsApiResponseOfPolicyOverviewResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets tokens representing the input policy ids.
     * @param x_policy_id (optional) The policy id which should be represented as a token.
     * @return OK
     */
    tokens(x_policy_id?: string[] | undefined): Observable<ApiResponseOfDictionaryOfString_String> {
        let url_ = this.baseUrl + "/v1/policy/tokens";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "x-policy-id": x_policy_id !== undefined && x_policy_id !== null ? "" + x_policy_id : "",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processTokens(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processTokens(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfDictionaryOfString_String>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfDictionaryOfString_String>;
        }));
    }

    protected processTokens(response: HttpResponseBase): Observable<ApiResponseOfDictionaryOfString_String> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfDictionaryOfString_String;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Executes a quick search for policy data, returning partial policy information per result.
     * @param body (optional) The search request to get policy data.
     * @return OK
     */
    search(body?: PolicySearchRequest | undefined): Observable<ApiResponseOfPolicySearchResultsResponse> {
        let url_ = this.baseUrl + "/v1/policy/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processSearch(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSearch(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfPolicySearchResultsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfPolicySearchResultsResponse>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<ApiResponseOfPolicySearchResultsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfPolicySearchResultsResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CypressClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Updates user preferences.
     * @param body (optional) The user preferences to update.
     * @return OK
     */
    accountPost(body?: CypressAccountRequest | undefined): Observable<ApiResponseOfCypressAccountResponse> {
        let url_ = this.baseUrl + "/v1/cypress/account";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processAccountPost(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processAccountPost(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfCypressAccountResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfCypressAccountResponse>;
        }));
    }

    protected processAccountPost(response: HttpResponseBase): Observable<ApiResponseOfCypressAccountResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfCypressAccountResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets user preferences.
     * @param emailId (optional) The emailId to look for cypress account info.
     * @return OK
     */
    accountGet(emailId?: string | undefined): Observable<ApiResponseOfCypressAccountResponse> {
        let url_ = this.baseUrl + "/v1/cypress/account?";
        if (emailId === null)
            throw new Error("The parameter 'emailId' cannot be null.");
        else if (emailId !== undefined)
            url_ += "emailId=" + encodeURIComponent("" + emailId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processAccountGet(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processAccountGet(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfCypressAccountResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfCypressAccountResponse>;
        }));
    }

    protected processAccountGet(response: HttpResponseBase): Observable<ApiResponseOfCypressAccountResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfCypressAccountResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DocumentsClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Searches for documents that on a policy that match the provided filter criteria.
     * @param body (optional) The document search request.
     * @return OK
     */
    search(body?: DocumentSearchRequest | undefined): Observable<FlagsApiResponseOfDocumentSearchResponse> {
        let url_ = this.baseUrl + "/v1/documents/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processSearch(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSearch(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FlagsApiResponseOfDocumentSearchResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FlagsApiResponseOfDocumentSearchResponse>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<FlagsApiResponseOfDocumentSearchResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FlagsApiResponseOfDocumentSearchResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns a Microsoft.AspNetCore.Mvc.FileContentResult from Symetra.Dcx.Components.Models.Immutable.Documents.SourceSystem.P8.
     * @param id (optional) The document id that maps to this document in p8.
     * @param policyToken (optional) The policy token that maps to this document in p8.
     * @return OK
     */
    p8(id?: string | undefined, policyToken?: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/v1/documents/p8?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (policyToken === null)
            throw new Error("The parameter 'policyToken' cannot be null.");
        else if (policyToken !== undefined)
            url_ += "policyToken=" + encodeURIComponent("" + policyToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/pdf"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processP8(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processP8(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processP8(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Indexes documents by policy id in a fire-and-forget fashion.
     * @param body The policy ids to index.
     * @return OK
     */
    ffindex(body: string[]): Observable<FlagsApiResponseOfBoolean> {
        let url_ = this.baseUrl + "/v1/documents/ffindex";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processFfindex(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processFfindex(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FlagsApiResponseOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FlagsApiResponseOfBoolean>;
        }));
    }

    protected processFfindex(response: HttpResponseBase): Observable<FlagsApiResponseOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FlagsApiResponseOfBoolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EmailClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Executes email sending.
     * @param body (optional) The ScheduleA letter request.
     * @return OK
     */
    send(body?: ScheduleAEmailServiceInput | undefined): Observable<ApiResponseOfBoolean> {
        let url_ = this.baseUrl + "/v1/email/send";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processSend(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSend(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfBoolean>;
        }));
    }

    protected processSend(response: HttpResponseBase): Observable<ApiResponseOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfBoolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Executes sending invoice notification email.
     * @param body (optional) The invoice notification request.
     * @return OK
     */
    sendinvoice(body?: InvoiceNotificationEmailServiceInput | undefined): Observable<ApiResponseOfBoolean> {
        let url_ = this.baseUrl + "/v1/email/sendinvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processSendinvoice(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSendinvoice(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfBoolean>;
        }));
    }

    protected processSendinvoice(response: HttpResponseBase): Observable<ApiResponseOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfBoolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class V1Client extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Saves form data.
     * @param body (optional) The form autosave request.
     * @return OK
     */
    savePost(body?: FormAutosaveRequest | undefined): Observable<ApiResponseOfFormAutosaveRecord> {
        let url_ = this.baseUrl + "/v1/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processSavePost(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSavePost(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfFormAutosaveRecord>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfFormAutosaveRecord>;
        }));
    }

    protected processSavePost(response: HttpResponseBase): Observable<ApiResponseOfFormAutosaveRecord> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfFormAutosaveRecord;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets saved form data.
     * @param formId The form ID.
     * @return OK
     */
    saveGet(formId: string): Observable<ApiResponseOfFormAutosaveRecord> {
        let url_ = this.baseUrl + "/v1/save/{formId}";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processSaveGet(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSaveGet(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfFormAutosaveRecord>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfFormAutosaveRecord>;
        }));
    }

    protected processSaveGet(response: HttpResponseBase): Observable<ApiResponseOfFormAutosaveRecord> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfFormAutosaveRecord;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Clears saved form data.
     * @param formId The form ID.
     * @return OK
     */
    saveDelete(formId: string): Observable<ApiResponseOfBoolean> {
        let url_ = this.baseUrl + "/v1/save/{formId}";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processSaveDelete(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSaveDelete(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfBoolean>;
        }));
    }

    protected processSaveDelete(response: HttpResponseBase): Observable<ApiResponseOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfBoolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class GroupClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets addresses for a group id.
     * @return OK
     */
    address(): Observable<ApiResponseOfGroupAddressResponse> {
        let url_ = this.baseUrl + "/v1/group/address";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processAddress(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processAddress(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfGroupAddressResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfGroupAddressResponse>;
        }));
    }

    protected processAddress(response: HttpResponseBase): Observable<ApiResponseOfGroupAddressResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfGroupAddressResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets contacts for a group id.
     * @return OK
     */
    contacts(): Observable<ApiResponseOfGroupContactResponse> {
        let url_ = this.baseUrl + "/v1/group/contacts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processContacts(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processContacts(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfGroupContactResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfGroupContactResponse>;
        }));
    }

    protected processContacts(response: HttpResponseBase): Observable<ApiResponseOfGroupContactResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfGroupContactResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets bill divisions for a group id.
     * @return OK
     */
    billdivisions(): Observable<ApiResponseOfArrayOfBillDivision> {
        let url_ = this.baseUrl + "/v1/group/billdivisions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processBilldivisions(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processBilldivisions(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfArrayOfBillDivision>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfArrayOfBillDivision>;
        }));
    }

    protected processBilldivisions(response: HttpResponseBase): Observable<ApiResponseOfArrayOfBillDivision> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfArrayOfBillDivision;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets plans for a group id.
     * @param classCodes (optional) Optional class codes to filter results by.
     * @param statuses (optional) Optional status list to filter results by.
     * @return OK
     */
    plans(classCodes?: string[] | undefined, statuses?: string[] | undefined): Observable<ApiResponseOfArrayOfPlan> {
        let url_ = this.baseUrl + "/v1/group/plans?";
        if (classCodes === null)
            throw new Error("The parameter 'classCodes' cannot be null.");
        else if (classCodes !== undefined)
            classCodes && classCodes.forEach(item => { url_ += "classCodes=" + encodeURIComponent("" + item) + "&"; });
        if (statuses === null)
            throw new Error("The parameter 'statuses' cannot be null.");
        else if (statuses !== undefined)
            statuses && statuses.forEach(item => { url_ += "statuses=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPlans(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPlans(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfArrayOfPlan>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfArrayOfPlan>;
        }));
    }

    protected processPlans(response: HttpResponseBase): Observable<ApiResponseOfArrayOfPlan> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfArrayOfPlan;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MemberClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets member detail for an employee.
     * @param body (optional) The request to retrieve member detail.
     * @return OK
     */
    detail(body?: MemberDetailSearchRequest | undefined): Observable<ApiResponseOfMemberDetailSearchResponse> {
        let url_ = this.baseUrl + "/v1/member/detail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDetail(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDetail(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfMemberDetailSearchResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfMemberDetailSearchResponse>;
        }));
    }

    protected processDetail(response: HttpResponseBase): Observable<ApiResponseOfMemberDetailSearchResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfMemberDetailSearchResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets member list for a policy.
     * @param body (optional) The request to retrieve member list.
     * @return OK
     */
    list(body?: MemberListSearchRequest | undefined): Observable<ApiResponseOfMemberListSearchResponse> {
        let url_ = this.baseUrl + "/v1/member/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processList(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processList(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfMemberListSearchResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfMemberListSearchResponse>;
        }));
    }

    protected processList(response: HttpResponseBase): Observable<ApiResponseOfMemberListSearchResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfMemberListSearchResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets member based on a searchTerm.
     * @param body (optional) The request to retrieve member list.
     * @return OK
     */
    lookup(body?: MemberLookupSearchRequest | undefined): Observable<ApiResponseOfListOfPerson> {
        let url_ = this.baseUrl + "/v1/member/lookup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processLookup(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processLookup(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfListOfPerson>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfListOfPerson>;
        }));
    }

    protected processLookup(response: HttpResponseBase): Observable<ApiResponseOfListOfPerson> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfListOfPerson;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets member detail for an employee.
     * @param body (optional) The request to add/update member.
     * @return OK
     */
    addupdatemember(body?: AddUpdateMemberRequest | undefined): Observable<ApiResponseOfMemberResponse> {
        let url_ = this.baseUrl + "/v1/member/addupdatemember";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processAddupdatemember(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processAddupdatemember(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfMemberResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfMemberResponse>;
        }));
    }

    protected processAddupdatemember(response: HttpResponseBase): Observable<ApiResponseOfMemberResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfMemberResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets member demographics.
     * @param memberId The memberId from UI.
     * @return OK
     */
    demographics(memberId: string): Observable<ApiResponseOfMemberDetailSearchResponse> {
        let url_ = this.baseUrl + "/v1/member/demographics?";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined and cannot be null.");
        else
            url_ += "memberId=" + encodeURIComponent("" + memberId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDemographics(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDemographics(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfMemberDetailSearchResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfMemberDetailSearchResponse>;
        }));
    }

    protected processDemographics(response: HttpResponseBase): Observable<ApiResponseOfMemberDetailSearchResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfMemberDetailSearchResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class Oauth2Client extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * An endpoint that returns a cookie for demo site authentication.
     * @param body (optional) The demo user request.
     * @return OK
     */
    demotoken(body?: DemoTokenRequest | undefined): Observable<FlagsApiResponseOfBoolean> {
        let url_ = this.baseUrl + "/v1/oauth2/demotoken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDemotoken(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDemotoken(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FlagsApiResponseOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FlagsApiResponseOfBoolean>;
        }));
    }

    protected processDemotoken(response: HttpResponseBase): Observable<FlagsApiResponseOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FlagsApiResponseOfBoolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * An endpoint that returns a cookie for authentication.
     * @param body (optional) The parameters from the client's POST body.
     * @return OK
     */
    token(body?: TokenRequest | undefined): Observable<FlagsApiResponseOfNull> {
        let url_ = this.baseUrl + "/v1/oauth2/token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processToken(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processToken(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FlagsApiResponseOfNull>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FlagsApiResponseOfNull>;
        }));
    }

    protected processToken(response: HttpResponseBase): Observable<FlagsApiResponseOfNull> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FlagsApiResponseOfNull;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Logs the user out and redirects them to GO home page.
     * @param goUrl GO url to redirect to.
     * @return OK
     */
    togo(goUrl: string): Observable<void> {
        let url_ = this.baseUrl + "/v1/oauth2/togo?";
        if (goUrl === undefined || goUrl === null)
            throw new Error("The parameter 'goUrl' must be defined and cannot be null.");
        else
            url_ += "goUrl=" + encodeURIComponent("" + goUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processTogo(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processTogo(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTogo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Logs the user out and redirects them back to the home page.
     * @param clientId The id of the client that initiated logout.
     * @return OK
     */
    logout(clientId: string): Observable<void> {
        let url_ = this.baseUrl + "/v1/oauth2/logout?";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined and cannot be null.");
        else
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processLogout(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processLogout(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLogout(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PaymentClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * CyberSource bank payment.
     * @param body (optional) Symetra.Benefits.Api.Contracts.CyberSource.PaymentRequest.
     * @return OK
     */
    bank(body?: PaymentRequest | undefined): Observable<ApiResponseOfPaymentResponse> {
        let url_ = this.baseUrl + "/v1/payment/bank";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processBank(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processBank(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfPaymentResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfPaymentResponse>;
        }));
    }

    protected processBank(response: HttpResponseBase): Observable<ApiResponseOfPaymentResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfPaymentResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PremiumClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets calculation information for an invoice.
     * @param body (optional) The searchRequest id to retrieve premium calculation information.
     * @return OK
     */
    calculation(body?: PremiumCalculationSearchRequest | undefined): Observable<ApiResponseOfPremiumCalculationSearchResponse> {
        let url_ = this.baseUrl + "/v1/premium/calculation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCalculation(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCalculation(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfPremiumCalculationSearchResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfPremiumCalculationSearchResponse>;
        }));
    }

    protected processCalculation(response: HttpResponseBase): Observable<ApiResponseOfPremiumCalculationSearchResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfPremiumCalculationSearchResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the total calculated premium amount.
     * @param body (optional) Premium calculator request.
     * @return OK
     */
    calculator(body?: PremiumCalculatorRequest | undefined): Observable<ApiResponseOfPremiumCalculatorInfo> {
        let url_ = this.baseUrl + "/v1/premium/calculator";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCalculator(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCalculator(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfPremiumCalculatorInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfPremiumCalculatorInfo>;
        }));
    }

    protected processCalculator(response: HttpResponseBase): Observable<ApiResponseOfPremiumCalculatorInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfPremiumCalculatorInfo;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets calculation information for an invoice.
     * @param body (optional) The submit request update premium calculation information.
     * @return OK
     */
    submit(body?: PremiumCalculationSubmitRequest | undefined): Observable<ApiResponseOfBoolean> {
        let url_ = this.baseUrl + "/v1/premium/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processSubmit(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSubmit(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfBoolean>;
        }));
    }

    protected processSubmit(response: HttpResponseBase): Observable<ApiResponseOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfBoolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ProfileClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * An endpoint that returns a profile photo for a contact.
     * @param email (optional) Email of contact
     * @return OK
     */
    photo(email?: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/v1/profile/photo?";
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "image/*"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPhoto(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPhoto(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPhoto(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class QuicksightClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets an embed URL for the QuickSight dashboard.
     * @param dashboardId The ID of the QuickSight dashboard to embed.
     * @return OK
     */
    embedUrl(dashboardId: string): Observable<ApiResponseOfString> {
        let url_ = this.baseUrl + "/v1/quicksight/embed-url/{dashboardId}";
        if (dashboardId === undefined || dashboardId === null)
            throw new Error("The parameter 'dashboardId' must be defined.");
        url_ = url_.replace("{dashboardId}", encodeURIComponent("" + dashboardId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processEmbedUrl(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processEmbedUrl(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfString>;
        }));
    }

    protected processEmbedUrl(response: HttpResponseBase): Observable<ApiResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfString;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SystemClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Returns a hardcoded string. Used to ensure the server is up and handling requests.
     * @return OK
     */
    ping(): Observable<ApiResponseOfString> {
        let url_ = this.baseUrl + "/v1/system/ping";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPing(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPing(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfString>;
        }));
    }

    protected processPing(response: HttpResponseBase): Observable<ApiResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfString;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class UserClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets information about the current user.
     * @return OK
     */
    info(): Observable<FlagsApiResponseOfUserInfoResponse> {
        let url_ = this.baseUrl + "/v1/user/info";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processInfo(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processInfo(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FlagsApiResponseOfUserInfoResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FlagsApiResponseOfUserInfoResponse>;
        }));
    }

    protected processInfo(response: HttpResponseBase): Observable<FlagsApiResponseOfUserInfoResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FlagsApiResponseOfUserInfoResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets information about the current user.
     * @param body (optional) The user info for the request.
     * @return OK
     */
    accept(body?: UserInfoRequest | undefined): Observable<ApiResponseOfBoolean> {
        let url_ = this.baseUrl + "/v1/user/accept";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processAccept(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processAccept(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfBoolean>;
        }));
    }

    protected processAccept(response: HttpResponseBase): Observable<ApiResponseOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfBoolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates user preferences.
     * @param body (optional) The user preferences to update.
     * @return OK
     */
    preferencePost(body?: UserPreferenceRequest | undefined): Observable<ApiResponseOfUserPreferenceResponse> {
        let url_ = this.baseUrl + "/v1/user/preference";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPreferencePost(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPreferencePost(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfUserPreferenceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfUserPreferenceResponse>;
        }));
    }

    protected processPreferencePost(response: HttpResponseBase): Observable<ApiResponseOfUserPreferenceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfUserPreferenceResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets user preferences.
     * @return OK
     */
    preferenceGet(): Observable<ApiResponseOfUserPreferenceResponse> {
        let url_ = this.baseUrl + "/v1/user/preference";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPreferenceGet(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPreferenceGet(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfUserPreferenceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfUserPreferenceResponse>;
        }));
    }

    protected processPreferenceGet(response: HttpResponseBase): Observable<ApiResponseOfUserPreferenceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfUserPreferenceResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export enum ActionType {
    Add_Person = "Add Person",
    Update_Person = "Update Person",
    Add_Member = "Add Member",
    Update_Member = "Update Member",
    Terminate_Member = "Terminate Member",
    Add_Beneficiary = "Add Beneficiary",
    Update_Beneficiary = "Update Beneficiary",
    Terminate_Beneficiary = "Terminate Beneficiary",
    Add_Dependent = "Add Dependent",
    Update_Dependent = "Update Dependent",
    Terminate_Dependent = "Terminate Dependent",
    Add_Coverage = "Add Coverage",
    Update_Coverage = "Update Coverage",
    Terminate_Coverage = "Terminate Coverage",
    Unknown = "Unknown",
}

/** Add or update member detail request. */
export interface AddUpdateMemberRequest {
    /** Member id. */
    memberId: string | undefined;
    /** Employee id. */
    employeeId: string | undefined;
    /** Contract id. */
    contractId: string | undefined;
    /** policy class id. */
    policyClassId: string | undefined;
    /** Billing Entity Id. */
    billingEntityId: string | undefined;
    /** Bill location. */
    billLocation: string | undefined;
    /** Job Site Code. */
    jobSiteCode: string | undefined;
    /** Occupation. */
    occupation: string | undefined;
    /** Date of hire. */
    hireDate: SymetraDateTime | undefined;
    /** Gets or sets the marital status of the insured. */
    maritalStatus: AddUpdateMemberRequestMaritalStatus | undefined;
    /** Gets or sets the phone number of the insured. */
    phone: string | undefined;
    /** Gets or sets the work phone number of the insured. */
    workPhone: string | undefined;
    /** Gets or sets the cell phone number of the insured. */
    cellPhone: string | undefined;
    /** Gets or sets the email address of the insured. */
    email: string | undefined;
    /** Gets or sets the address information of the insured. */
    addressInfo: Address | undefined;
    /** First name. */
    firstName: string | undefined;
    /** Middle name. */
    middleName: string | undefined;
    /** Last name. */
    lastName: string | undefined;
    /** Suffix. */
    suffix: string | undefined;
    /** Date of birth. */
    birthDate: SymetraDateTime | undefined;
    /** SSN. */
    ssn: string | undefined;
    /** Gets or inits the Social Security Number of the member. */
    maskedSSN: string | undefined;
    /** Gets or sets the status of the member. */
    status: AddUpdateMemberRequestStatus | undefined;
    /** Member smoker status. */
    smokerStatus: AddUpdateMemberRequestSmokerStatus | undefined;
    /** Date of birth. */
    gender: AddUpdateMemberRequestGender | undefined;
    /** Gets or sets the effective date of the member's policy. */
    effDate: SymetraDateTime | undefined;
    /** Gets or sets the termination date of the member. */
    termDate: SymetraDateTime | undefined;
    /** Gets or sets the member type. */
    memberType: AddUpdateMemberRequestMemberType | undefined;
    /** Relationship. */
    relationship: AddUpdateMemberRequestRelationship | undefined;
    /** Gets or inits the action type. */
    actionType: AddUpdateMemberRequestActionType | undefined;
    /** Coverage. */
    coverages: MemberCoverage[] | undefined;
    /** Dependents. */
    dependents: Dependent[] | undefined;
    /** Salary collection. */
    salaries: MemberSalary[] | undefined;
    /** Gets or inits the audit info for the insured. */
    audit: AuditInfo | undefined;
}

export interface Address {
    addressLine1: string | undefined;
    addressLine2: string | undefined;
    addressLine3: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zipCode: string | undefined;
    startDate: SymetraDateTime | undefined;
}

/** High-level information about all forms response. */
export interface AllFormsResponse {
    /** The Claims form. */
    claimsForms: FormResponse[] | undefined;
    /** The Custom forms. */
    customForms: FormResponse[] | undefined;
    /** The Employee forms. */
    employeeForms: FormResponse[] | undefined;
    /** The Group Id. */
    groupId: string | undefined;
    /** The Tax forms. */
    taxForms: FormResponse[] | undefined;
}

export interface ApiResponseOfAllFormsResponse {
    /** High-level information about all forms response. */
    data: AllFormsResponse | undefined;
    messages: LocalizedMessage[];
}

export interface ApiResponseOfArrayOfBillDivision {
    data: BillDivision[] | undefined;
    messages: LocalizedMessage[];
}

export interface ApiResponseOfArrayOfClaimInfo {
    data: ClaimInfo[] | undefined;
    messages: LocalizedMessage[];
}

export interface ApiResponseOfArrayOfCustomClaimsReportInfo {
    data: CustomClaimsReportInfo[] | undefined;
    messages: LocalizedMessage[];
}

export interface ApiResponseOfArrayOfPlan {
    data: Plan[] | undefined;
    messages: LocalizedMessage[];
}

export interface ApiResponseOfArrayOfString {
    data: string[] | undefined;
    messages: LocalizedMessage[];
}

export interface ApiResponseOfBoolean {
    data: boolean;
    messages: LocalizedMessage[];
}

export interface ApiResponseOfClaimDetailsResponse {
    /** High-level information about a Claim Details response. */
    data: ClaimDetailsResponse | undefined;
    messages: LocalizedMessage[];
}

export interface ApiResponseOfClaimsListResponse {
    /** Contract for Claim List. */
    data: ClaimsListResponse | undefined;
    messages: LocalizedMessage[];
}

export interface ApiResponseOfCluSearchResponse {
    /** Contract for Claim Loss Unit. */
    data: CluSearchResponse | undefined;
    messages: LocalizedMessage[];
}

export interface ApiResponseOfCypressAccountResponse {
    data: CypressAccountResponse | undefined;
    messages: LocalizedMessage[];
}

export interface ApiResponseOfDictionaryOfString_String {
    data: { [key: string]: string; } | undefined;
    messages: LocalizedMessage[];
}

export interface ApiResponseOfEOIApplicationsReponse {
    /** Overview of significant dates on the policy, and other high-level policy information. */
    data: EOIApplicationsReponse | undefined;
    messages: LocalizedMessage[];
}

export interface ApiResponseOfFormAutosaveRecord {
    data: FormAutosaveRecord | undefined;
    messages: LocalizedMessage[];
}

export interface ApiResponseOfGroupAddressResponse {
    data: GroupAddressResponse | undefined;
    messages: LocalizedMessage[];
}

export interface ApiResponseOfGroupContactResponse {
    data: GroupContactResponse | undefined;
    messages: LocalizedMessage[];
}

export interface ApiResponseOfListOfPerson {
    data: Person[] | undefined;
    messages: LocalizedMessage[];
}

export interface ApiResponseOfMemberDetailSearchResponse {
    /** Contract for member detail response. */
    data: MemberDetailSearchResponse | undefined;
    messages: LocalizedMessage[];
}

export interface ApiResponseOfMemberListSearchResponse {
    /** Contract for member list. */
    data: MemberListSearchResponse | undefined;
    messages: LocalizedMessage[];
}

export interface ApiResponseOfMemberResponse {
    data: MemberResponse | undefined;
    messages: LocalizedMessage[];
}

export interface ApiResponseOfPaymentResponse {
    data: PaymentResponse | undefined;
    messages: LocalizedMessage[];
}

export interface ApiResponseOfPolicyClaimsFlagsResponse {
    /** Representation of Claim entity. */
    data: PolicyClaimsFlagsResponse | undefined;
    messages: LocalizedMessage[];
}

export interface ApiResponseOfPolicyCoveragesResponse {
    /** Coverages associated with a given policy. */
    data: PolicyCoveragesResponse | undefined;
    messages: LocalizedMessage[];
}

export interface ApiResponseOfPolicySearchResultsResponse {
    /** Response contract for the search endpoint. */
    data: PolicySearchResultsResponse | undefined;
    messages: LocalizedMessage[];
}

export interface ApiResponseOfPremiumCalculationSearchResponse {
    /** Contract for premium. */
    data: PremiumCalculationSearchResponse | undefined;
    messages: LocalizedMessage[];
}

export interface ApiResponseOfPremiumCalculatorInfo {
    data: PremiumCalculatorInfo | undefined;
    messages: LocalizedMessage[];
}

export interface ApiResponseOfScheduleALetterSearchResponse {
    /** Erisa ScheduleA Letters response to UI. */
    data: ScheduleALetterSearchResponse | undefined;
    messages: LocalizedMessage[];
}

export interface ApiResponseOfSearchClaimResponse {
    data: SearchClaimResponse | undefined;
    messages: LocalizedMessage[];
}

export interface ApiResponseOfString {
    data: string | undefined;
    messages: LocalizedMessage[];
}

export interface ApiResponseOfSymetraEmployeeContactResponse {
    /** Representation of Contact. */
    data: SymetraEmployeeContactResponse | undefined;
    messages: LocalizedMessage[];
}

export interface ApiResponseOfUserPreferenceResponse {
    data: UserPreferenceResponse | undefined;
    messages: LocalizedMessage[];
}

export interface AuditInfo {
    insertedBy: string | undefined;
    updatedBy: string | undefined;
    sortName: string | undefined;
    insertedDate: SymetraDateTime | undefined;
    updatedDate: SymetraDateTime | undefined;
}

export interface BenefitDefinition {
    benefitAmountRange: string | undefined;
    benefitDefinitionMultiple: string | undefined;
    benefitDefinitionPercen: string | undefined;
    benefitDefn: string | undefined;
    benefitElectionStyle: string | undefined;
    benefitPackages: BenefitPackage[] | undefined;
    benefitPercent: string | undefined;
    benefitPercentageCalc: string | undefined;
    earningMultipleRangeMax: string | undefined;
    earningMultipleRangeMin: string | undefined;
    earningsMultipleIncrement: string | undefined;
    earningsMultiples: string | undefined;
    enrollmentElectionStyle: string | undefined;
    flatAdjustmentAmt: string | undefined;
    flatAdjustmentStyle: string | undefined;
    flatAmountRangeMaximum: string | undefined;
    flatAmountRangeMinimum: string | undefined;
    flatAmounts: string | undefined;
    gradedPlanClasses: GradedPlanClass[] | undefined;
    gradedPlanType: string | undefined;
    limitApplication: string | undefined;
    limitCoveragetoAvoidComputedIncome: string | undefined;
    linkedRequirement: string | undefined;
    linkToPOBComponents: LinkToPOBComponents[] | undefined;
    maxEarningsMultiple: string | undefined;
    maxGrossMonthlyBenefit: string | undefined;
    maxPercentOfCPP: string | undefined;
    maxPercentOfEI: string | undefined;
    maxPercentOfQPP: string | undefined;
    maxPercentageBenefit: string | undefined;
    maxPercentageEarning: string | undefined;
    maxWeeklyBenefit: string | undefined;
    maxWeeklyBenfitMultiple: string | undefined;
    maximumFlat: string | undefined;
    maximumStyle: string | undefined;
    maximumWeeklyBenefitAmountAgriculturalWorkers: string | undefined;
    minEarningsMultiple: string | undefined;
    minGrossMonthlyBenefit: string | undefined;
    minPercentBenefit: string | undefined;
    minPercentEarning: string | undefined;
    minPercentOfCPP: string | undefined;
    minPercentOfEI: string | undefined;
    minPercentOfQPP: string | undefined;
    minWeeklyBenefit: string | undefined;
    minimumFlat: string | undefined;
    minimumSawwThreshold: string | undefined;
    minimumStyle: string | undefined;
    nonBasisRounding: string | undefined;
    otherBeneElectionStyle: string | undefined;
    others: string | undefined;
    overrideBenefit: string | undefined;
    packageTypes: string | undefined;
    percentWeeklyEarningsBelowSAWW: string | undefined;
    planBenefitDefnId: string | undefined;
    rangeIncrement: string | undefined;
    reqBeyondLmtAction: string | undefined;
    roundingApplication: string | undefined;
    roundingIncrement: string | undefined;
    roundingRule: string | undefined;
    statMinWeeklyBenStyle: string | undefined;
    statesMaxWeeklyBenefitStyle: string | undefined;
}

export interface BenefitPackage {
    displayName: string | undefined;
    id: string | undefined;
    childBenefit: string | undefined;
    childBenefitPercent: string | undefined;
    childBenefitSpch: string | undefined;
    internalName: string | undefined;
    spouseBenefit: string | undefined;
    spouseBenefitPercent: string | undefined;
    spouseBenefitSpch: string | undefined;
}

export interface BenefitPackageInfo {
    internalName: string | undefined;
    childBenefitSpch: number;
    displayName: string | undefined;
    spouseBenefitSpch: number;
    spouseBenefit: number;
    childBenefit: number;
}

export enum BenefitsModelsImmutableDocumentsDocumentCategory {
    Absence = "Absence",
    All = "All",
    BillingStatements = "BillingStatements",
    Contracts = "Contracts",
    Correspondence = "Correspondence",
    InsufficientCviNotice = "InsufficientCviNotice",
    Life = "Life",
    LoanInterestNotices = "LoanInterestNotices",
    LoanPremiumComboNotices = "LoanPremiumComboNotices",
    LTD = "LTD",
    NCE = "NCE",
    Notice = "Notice",
    NYPFL = "NYPFL",
    PastDuePremiumNotices = "PastDuePremiumNotices",
    PFML = "PFML",
    Policies = "Policies",
    RegularPremiumNotices = "RegularPremiumNotices",
    RenewalNotices = "RenewalNotices",
    SB = "SB",
    SBCert = "SBCert",
    SL = "SL",
    Statements = "Statements",
    STD = "STD",
    Unknown = "Unknown",
}

export interface BillDivision {
    id: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    code: string | undefined;
}

export interface BillingPeriod {
    from: SymetraDateTime | undefined;
    to: SymetraDateTime | undefined;
}

/** High-level information about a billing response. */
export interface BillingResponse {
    /** The amount the billing belongs to. */
    amount: number;
    /** The amount the billing belongs to for UI. */
    amountUI: string | undefined;
    /** The balance due amount. */
    balanceDue: number;
    /** The bill group name the billing belongs to. */
    billGroupName: string | undefined;
    /** The bill group number the billing belongs to. */
    billGroupNumber: string | undefined;
    /** The billing type the billing belongs to. */
    billingType: string | undefined;
    /** The carried over amount. */
    carriedOverAmount: number;
    /** The due date. */
    dueDate: SymetraDateTime | undefined;
    /** The due date key. */
    dueDatekey: string | undefined;
    /** Excel file uri associated with the document. */
    excelFileUri: string | undefined;
    /** Excel mime Type with the document. */
    excelMimeType: BillingResponseExcelMimeType | undefined;
    /** File uri associated with the PDF document. */
    fileUri: string | undefined;
    /** The invoice amount. */
    invoiceAmount: number;
    /** The invoice number the billing belongs to. */
    invoiceNumber: string | undefined;
    /** The coverage start date. */
    coverageStartDate: string | undefined;
    /** The coverage stop date. */
    coverageStopDate: string | undefined;
    /** The invoice key the billing belongs to. */
    invoiceKey: string | undefined;
    /** The premium key the billing belongs to. */
    premiumKey: string | undefined;
    /** The invoice period the billing belongs to. */
    invoicePeriod: BillingPeriod | undefined;
    /** Mime Type with the PDF document. */
    mimeType: BillingResponseMimeType | undefined;
    /** The paid amount. */
    paidAmount: number;
    /** The PolicyId of billing. */
    policyId: string | undefined;
    /** The Premium Details ID. */
    premiumDetailsId: string | undefined;
    /** The run date the billing belongs to. */
    runDate: SymetraDateTime | undefined;
    /** Statement date of billing. */
    statementDate: SymetraDateTime | undefined;
    /** The status the billing belongs to. */
    status: string | undefined;
    /** The stop date. */
    stopDate: SymetraDateTime | undefined;
    /** The flag to indicate this billing has due amount or not. */
    hasDueAmount: boolean;
    /** TThe 2nd notice days of billing. */
    secondNoticeDays: number;
    /** The 3rd notice days of billing. */
    thirdNoticeDays: number;
    /** The comment submitted by of billing. */
    submittedBy: string;
    /** The comment submitted date of billing. */
    submittedDate: string;
    /** The sa comment of billing. */
    saComment: string;
}

/** Billing Search Request. */
export interface BillingSearchRequest {
    /** Bill group number to search the billings. */
    billGroupNumber: string | undefined;
    /** Invoice number to search the billings. */
    invoiceNumber: string | undefined;
    /** Invoice period to search the billings. */
    readonly invoicePeriod: BillingPeriod | undefined;
    /** Invoice period to search the billings. */
    invoicePeriodString: string | undefined;
    /** Page number for the search results. */
    page: number;
    /** Page size for the search results. */
    pageSize: number;
    /** Policy Number to search the billings. */
    policyId: string | undefined;
    /** Run date from to search the billings. */
    runDateFrom: SymetraDateTime | undefined;
    /** Run date to search the billings. */
    runDateTo: SymetraDateTime | undefined;
    /** Billings Status to search the billings. */
    status: string | undefined;
    /** The direction to sort the search results by (Ascending or Descending). */
    sortDirection: SearchSortDirection;
    /** The field to sort the search results by. */
    sortField: SearchSortField;
    /** The field to indicate Clear Cache. */
    clearCache: boolean;
    /** The field to indicate Refresh Cache. */
    refreshCache: boolean;
}

/** Contract for billings. */
export interface BillingSearchResponse {
    /** Policy Number associated with the billing. */
    policyId: string | undefined;
    /** Billings associated with the billing. */
    billings: BillingResponse[] | undefined;
    /** Billings associated with the billing. */
    billingPeriodList: string[] | undefined;
    /** Billings associated with the billing. */
    billingGroupList: string[] | undefined;
    /** Results per page. */
    resultsPerPage: number;
    /** Results per page. */
    currentPage: number;
    /** Total pages of results. */
    totalPages: number;
    /** Total number of results across all pages. */
    totalResults: number;
    /** The field to sort the search results by. */
    sortField: SearchSortField;
    /** The direction to sort the search results by (Ascending or Descending). */
    sortDirection: SearchSortDirection;
}

export interface ClaimAttachment {
    confirmationNumber: string;
    file: string;
    updateDate: string;
    type: string;
    size: number;
}

/** Represents the response details of a claim. */
export interface ClaimDetailInfoResponse {
    /** Gets or sets the claim ID. */
    id: string;
    /** Gets or sets the claimant's name. */
    claimantName: string;
    /** Gets or sets the claimant's first name. */
    firstName: string;
    /** Gets or sets the claimant's last name. */
    lastName: string;
    /** Gets or sets the policy number. */
    policyNumber: string;
    /** Gets or sets the claim number. */
    claimNumber: string;
    /** Gets or sets the claim status. */
    claimStatus: string;
    /** Gets or sets the status reason. */
    statusReason: string;
    /** Gets or sets the decision. */
    decision: string;
    /** Gets or sets the stop loss claim status. */
    claimStatusStopLoss: string;
    /** Gets or sets the received date. */
    receivedDate: string;
    /** Gets or sets the coverages. */
    coverages: string;
    /** Gets or sets the company. */
    company: string;
    /** Gets or sets the company ID. */
    companyID: string;
    /** Gets or sets the certified through date. */
    certifiedThroughDate: string;
    /** Gets or sets the date of disability. */
    dateOfDisability: string;
    /** Gets or sets a value indicating whether the claim is ASO. */
    isASO: boolean;
    /** Gets or sets a value indicating whether the Hawaii TDI indicator is set. */
    hawaiiTDIIndicator: boolean;
    /** Gets or sets the examiner. */
    examiner: string;
    /** Gets or sets the requested amount. */
    requested: number;
    /** Gets or sets the reimbursement amount. */
    reimbursement: number;
    /** Gets or sets the TPA paid amount. */
    tpaPaidAmount: string;
    /** Gets or sets the formatted requested amount. */
    requestedFormatted: string;
    /** Gets or sets the formatted reimbursement amount. */
    reimbursementFormatted: string;
    /** Gets or sets the plan year. */
    planYear: PlanYear[];
    /** Gets or sets the pended reason. */
    pendedReason: string;
    /** Gets or sets the deductible. */
    deductible: string;
    /** Gets or sets the individual advantage deductible. */
    individualAdvantageDeductible: string;
    /** Gets or sets the adjustments. */
    adjustments: string[];
    /** Gets or sets the adjustments explanation. */
    adjustmentsExplanation: string[];
    /** Gets or sets the check number. */
    checkNumber: string;
    /** Gets or sets the check date. */
    checkDate: string;
    /** Gets or sets the EFT. */
    eft: string;
    /** Gets or sets the effective date. */
    effectiveDate: string;
    /** Gets or sets the salary. */
    salary: string;
    /** Gets or sets the date of birth. */
    dateOfBirth: string;
    /** Gets or sets the date of hire. */
    dateOfHire: string;
    /** Gets or sets the gender. */
    gender: string;
    /** Gets or sets the mailing state. */
    mailingState: string;
    /** Gets or sets the date received. */
    dateReceived: string;
    /** Gets or sets the benefit name. */
    benefitName: string;
    /** Gets or sets the death date. */
    deathDate: string;
    /** Gets or sets the elimination period. */
    eliminationPeriod: string;
    /** Gets or sets the benefit percentage. */
    benefitPercentage: string;
    /** Gets or sets the benefit flat amount. */
    benefitFlatAmount: string;
    /** Gets or sets the maximum benefit amount. */
    maximumBenefitAmount: string;
    /** Gets or sets the maximum benefit period. */
    maximumBenefitPeriod: string;
    /** Gets or sets the benefit service. */
    benefitService: string;
    /** Gets or sets the duration of benefits. */
    durationOfBenefits: string;
    /** Gets or sets the last worked date. */
    lastWorkedDate: string;
    /** Gets or sets the benefit start date. */
    benefitStartDate: string;
    /** Gets or sets the date type. */
    dateType: string;
    /** Gets or sets the benefit amount. */
    benefitAmount: string;
    /** Gets or sets the payment start date. */
    paymentStartDate: string;
    /** Gets or sets the payment frequency. */
    paymentFrequency: string;
    /** Gets or sets the maximum benefit date. */
    maximumBenefitDate: string;
    /** Gets or sets the minimum benefit amount. */
    minimumBenefitAmount: string;
    /** Gets or sets the paid days. */
    paidDays: string;
    /** Gets or sets the BADD benefit. */
    baddBenefit: string;
    /** Gets or sets the BLIF benefit. */
    blifBenefit: string;
    /** Gets or sets the SADD benefit. */
    saddBenefit: string;
    /** Gets or sets the SLIF benefit. */
    slifBenefit: string;
    /** Gets or sets the BADD benefit name. */
    baddBenefitName: string;
    /** Gets or sets the BLIF benefit name. */
    blifBenefitName: string;
    /** Gets or sets the SADD benefit name. */
    saddBenefitName: string;
    /** Gets or sets the SLIF benefit name. */
    slifBenefitName: string;
    /** Gets or sets the BADD benefit face amount. */
    baddBenefit_FaceAmount: string;
    /** Gets or sets the BLIF benefit face amount. */
    blifBenefit_FaceAmount: string;
    /** Gets or sets the SADD benefit face amount. */
    saddBenefit_FaceAmount: string;
    /** Gets or sets the SLIF benefit face amount. */
    slifBenefit_FaceAmount: string;
    /** Gets or sets the BADD benefit status. */
    baddBenefit_Status: string;
    /** Gets or sets the BLIF benefit status. */
    blifBenefit_Status: string;
    /** Gets or sets the SADD benefit status. */
    saddBenefit_Status: string;
    /** Gets or sets the SLIF benefit status. */
    slifBenefit_Status: string;
    /** Gets or sets the BWOP status. */
    bwoP_Status: string;
    /** Gets or sets the BWOP benefit face amount. */
    bwopBenefit_FaceAmount: string;
    /** Gets or sets the SWOP status. */
    swoP_Status: string;
    /** Gets or sets the SWOP benefit face amount. */
    swopBenefit_FaceAmount: string;
    /** Gets or sets the minimum initial decision date. */
    minInitialDecisionDate: string;
    /** Gets or sets the policy name. */
    policyName: string;
    /** Gets or sets the record type name. */
    recordTypeName: string;
    /** Gets or sets the closed date. */
    closedDate: string;
    /** Gets or sets the age. */
    age: string;
    /** Gets or sets the account ID. */
    account_id: string;
    /** Gets or sets the benefit. */
    benefit: string;
    /** Gets or sets the face amount. */
    faceAmount: string;
    /** Gets or sets the benefit status. */
    benefitStatus: string;
    /** Gets or sets the age at death. */
    ageAtDeath: string;
    /** Gets or sets the effective date of coverage. */
    effectiveDateOfCoverage: string;
    /** Gets or sets the waiver benefit start date. */
    waiverBenefitStartDate: string;
    /** Gets or sets the waiver benefit through date. */
    waiverBenefitThroughDate: string;
    /** Gets or sets the absence type. */
    absenceType: string;
    /** Gets or sets the employee ID. */
    employeeId: string;
    /** Gets or sets the hours remaining. */
    hoursRemaining: string;
    /** Gets or sets the application deadline. */
    applicationDeadline: string;
    /** Gets or sets the reason. */
    reason: string;
    /** Gets or sets the relationship. */
    relationship: string;
    /** Gets or sets the leave type. */
    leaveType: string;
    /** Gets or sets the frequency and duration. */
    frequencyAndDuration: string;
    /** Gets or sets the hours pending. */
    hoursPending: string;
    /** Gets or sets the hours approved. */
    hoursApproved: string;
    /** Gets or sets the hours denied. */
    hoursDenied: string;
    /** Gets or sets the reporting period. */
    reportingPeriod: string;
    /** Gets or sets the determination date. */
    determinationDate: string;
    /** Gets or sets a value indicating whether the claim is ASOFS. */
    isASOFS: boolean;
    /** Gets or sets a value indicating whether the claim is ASOAP. */
    isASOAP: boolean;
    /** Gets or sets a value indicating whether the claim is ASOBD. */
    isASOBD: boolean;
    /** Gets or sets a value indicating whether the claim has a spouse or child. */
    hasSpouseOrChild: boolean;
    /** Gets or sets the claim type. */
    claimType: ClaimTypeEnum;
    /** Gets or sets a value indicating whether the claim has absence claims. */
    hasAbsenceClaims: boolean;
    /** Gets or sets a value indicating whether the claim has disability claims. */
    hasDisabilityClaims: boolean;
    /** Gets or sets a value indicating whether the claim has life claims. */
    hasLifeClaims: boolean;
    /** Gets or sets a value indicating whether the claim has ASO claims. */
    hasASOClaims: boolean;
    /** Gets or sets a value indicating whether the claim has disability paid claims. */
    hasDisabilityPaidClaims: boolean;
    /** Gets or sets a value indicating whether the claim has PFL claims. */
    hasPFLClaims: boolean;
    /** Gets or sets a value indicating whether the claim has accommodation claims. */
    hasAccommodationClaims: boolean;
}

/** Represents a search for Claim detail. */
export interface ClaimDetailRequest {
    /** The Policy Number. */
    policyNumber: string;
    /** The Claim Number. */
    claimNumber: string;
    /** The Coverage. */
    coverage: string;
}

/** High-level information about a Claim Details response. */
export interface ClaimDetailsResponse {
    /** GroupId. */
    groupId: string;
    /** Gets or sets the claim detail information. */
    claimInformation: ClaimDetailInfoResponse;
    /** Gets or sets the claim payment information. */
    claimPayment: ClaimPaymentResponse[];
    /** Gets or sets the intermittent occurrence information. */
    intermittentOccurrence: IntermittentOccurrenceInfo[];
}

export interface ClaimInfo {
    policyNumber: string;
    id: string;
    firstName: string;
    lastName: string;
    claimNumber: string;
    status: string;
    coverages: string;
    receivedDate: string | undefined;
    company: string;
    locationId: string;
    requested: number;
    reimbursement: number;
    effectiveDate: string;
    hasAbsenceClaims: boolean;
    hasDisabilityClaims: boolean;
    hasLifeClaims: boolean;
    hasASOClaims: boolean;
    hasDisabilityPaidClaims: boolean;
    hasPFLClaims: boolean;
    hasAccommodationClaims: boolean;
    checkDate: string | undefined;
    type: string;
    dentalFlag: string;
    checkRunId: string;
    decision: string;
}

/** Representation of Claim entity. */
export interface ClaimPaymentResponse {
    /** Gets or sets the claim number. */
    claimNumber: string;
    /** Gets or sets the policy number. */
    policyNumber: string;
    /** Gets or sets the benefit name. */
    benefitName: string;
    /** Gets or sets the class name. */
    className: string;
    /** Gets or sets the payment name. */
    paymentName: string;
    /** Gets or sets the payment status. */
    paymentStatus: string;
    /** Gets or sets the payment record type. */
    paymentRecordType: string;
    /** Gets or sets the payee name. */
    payeeName: string;
    /** Gets or sets the base benefit amount. */
    baseBenefitAmount: string;
    /** Gets or sets the interest amount. */
    interestAmount: string;
    /** Gets or sets the other benefit amount. */
    otherBenefitAmount: string;
    /** Gets or sets the amount paid. */
    amountPaid: string;
    /** Gets or sets the total amount. */
    totalAmount: string;
    /** Gets or sets the payment check number. */
    paymentCheckNumber: string;
    /** Gets or sets the payment start date. */
    paymentStartDate: string;
    /** Gets or sets the payment end date. */
    paymentEndDate: string;
    /** Gets or sets the date type. */
    dateType: string;
    /** Gets or sets the payment print date. */
    paymentPrintDate: string;
    /** Gets or sets the gross amount. */
    grossAmount: string;
    /** Gets or sets the taxes amount. */
    taxesAmount: string;
    /** Gets or sets the adjustments amount. */
    adjustmentsAmount: string;
    /** Gets or sets the FICA tax amount. */
    ficaTaxAmount: string;
    /** Gets or sets the Medicare tax amount. */
    medicareTaxAmount: string;
    /** Gets or sets the state income tax amount. */
    stateIncomeTaxAmount: string;
    /** Gets or sets the federal income tax amount. */
    federalIncomeTaxAmount: string;
    /** Gets or sets the other adjustment. */
    otherAdjustment: string;
    /** Gets or sets the net payment. */
    netPayment: string;
}

/** Representation of Claim entity. */
export interface ClaimResponse {
    /** Gets or sets the claim ID. */
    id: string;
    /** Gets or sets the first name of the claimant. */
    firstName: string;
    /** Gets or sets the last name of the claimant. */
    lastName: string;
    /** Gets or sets the claim number. */
    claimNumber: string;
    /** Gets or sets the status of the claim. */
    status: string;
    /** Gets or sets the coverages of the claim. */
    coverages: string;
    /** Gets or sets the received date of the claim. */
    receivedDate: string | undefined;
    /** Gets or sets the received date of the claim. */
    receivedDateFormatted: string;
    /** Gets or sets the company associated with the claim. */
    company: string;
    /** Gets or sets the location ID associated with the claim. */
    companyID: string;
    /** Gets or sets the requested amount for the claim. */
    requested: number;
    /** Gets or sets the reimbursement amount for the claim. */
    reimbursement: number;
    /** Gets or sets the reimbursement amount for the claim. */
    reimbursementFormatted: string;
    /** Gets or sets the reimbursement amount for the claim. */
    requestedFormatted: string;
    /** Gets or sets the effective date of the claim. */
    effectiveDate: string;
    /** Gets or sets a value indicating whether the claim has absence claims. */
    hasAbsenceClaims: boolean;
    /** Gets or sets a value indicating whether the claim has disability claims. */
    hasDisabilityClaims: boolean;
    /** Gets or sets a value indicating whether the claim has life claims. */
    hasLifeClaims: boolean;
    /** Gets or sets a value indicating whether the claim has ASO claims. */
    hasASOClaims: boolean;
    /** Gets or sets a value indicating whether the claim has disability paid claims. */
    hasDisabilityPaidClaims: boolean;
    /** Gets or sets a value indicating whether the claim has PFL claims. */
    hasPFLClaims: boolean;
    /** Gets or sets a value indicating whether the claim has accommodation claims. */
    hasAccommodationClaims: boolean;
    /** Gets or sets the check date of the claim. */
    checkDate: string | undefined;
    /** Gets or sets the type of the claim. */
    type: string;
    /** Gets or sets the dental flag of the claim. */
    dentalFlag: string;
    /** Gets or sets the check run ID of the claim. */
    checkRunId: string;
    /** Gets or sets the decision of the claim. */
    decision: string;
}

export enum ClaimStatusEnum {
    Closed = "Closed",
    Incomplete = "Incomplete",
    Open = "Open",
    Pending = "Pending",
    Unknown = "Unknown",
}

export interface ClaimSubmission {
    requestor: string;
    policyNumber: string;
    policyHolder: string;
    notes: string;
    confirmationEmail: string;
    confirmationNumber: string;
    claimType: string;
    claimantType: string;
    reasonForLeave: string;
    needForLeave: string;
    typeOfLeave: string;
    lastName: string;
    firstName: string;
    middleInitial: string;
    streetAddress: string;
    city: string;
    stateCode: string;
    zip: string;
    social1: string;
    social2: string;
    social3: string;
    birthDate: string;
    phoneAreaCode: string;
    phonePrefix: string;
    phoneSuffix: string;
    phoneExtension: string;
    company: string;
    hireDate: string;
    isSpanishInterpreterNeeded: string;
    translatorLanguage: string;
    lastDayWorked: string;
    firstDayMissed: string;
    timeMissedHours: string;
    timeMissedMinutes: string;
    sundayHours: string;
    sundayMinutes: string;
    mondayHours: string;
    mondayMinutes: string;
    tuesdayHours: string;
    tuesdayMinutes: string;
    wednesdayHours: string;
    wednesdayMinutes: string;
    thursdayHours: string;
    thursdayMinutes: string;
    fridayHours: string;
    fridayMinutes: string;
    saturdayHours: string;
    saturdayMinutes: string;
    doesScheduleVary: string;
    numberOfHourWorkedInPast12Months: string;
    timeMissedFromWork: boolean;
    accommodationStartDate: string;
    supervisorName: string;
    breathing: boolean;
    learning: boolean;
    lifting: boolean;
    reading: boolean;
    sitting: boolean;
    standing: boolean;
    walking: boolean;
    talking: boolean;
    concentrating: boolean;
    hearing: boolean;
    manualTasks: boolean;
    communicating: boolean;
    otherDifficulty: boolean;
    otherDifficultyDescription: string;
    equipment: boolean;
    workAtHome: boolean;
    accessibleMaterials: boolean;
    modifiedWorkSchedule: boolean;
    changesToWorkplace: boolean;
    reassignment: boolean;
    jobRestructuring: boolean;
    pregnancyRelatedSupport: boolean;
    transitionalDutyAssignment: boolean;
    lactationSupport: boolean;
    serviceAnimal: boolean;
    accessibleWorkplace: boolean;
    accessibleTechnology: boolean;
    stool: boolean;
    otherAccommodationType: boolean;
    additionalBreaks: boolean;
    transportationParking: boolean;
    transportationShuttle: boolean;
    leaveReason: string;
    otherAccommodationDescription: string;
    classNumber: string;
    weeklySalary: string;
    effectiveDate: string;
    monthlySalary: string;
    dateOfDeath: string;
    terminationDate: string;
    occupation: string;
    lastPremiumPaidDate: string;
    hoursPerWeek: string;
    wasConversionAppliedFor: string;
    dependentLastName: string;
    dependentFirstName: string;
    dependentMiddleInitial: string;
    dependentStreetAddress: string;
    dependentCity: string;
    dependentStateCode: string;
    dependentZip: string;
    dependentRelationshipToPrimary: string;
    dependentSocial1: string;
    dependentSocial2: string;
    dependentSocial3: string;
    dependentBirthDate: string;
    employer_Id: string;
    employer: string;
    carrier_Id: string;
    plan_Id: string;
    member_Id: string;
    eff_Date: string;
    dos: string;
    addressChange: boolean;
    service_Date: string;
    serviceType: string | undefined;
    accidentRelated: boolean;
    accidentDate: string | undefined;
    accidentLocation: string;
    accidentExplanation: string;
    memberDemographic: Demographic;
    documents: ClaimAttachment[];
    diagnosisDate: string;
    marriageDate: string;
    preferredContactMethod: string;
    diagnosisDescription: string;
    primaryCarePhysician: string;
    physicianTreatedPreviously: string;
    previousTreatment: boolean;
    details: string;
    timeAwayReason: string;
    timeAwayOther: string;
    timeAwayType: string;
    pregnancyComplications: string;
    pregnancyDate: string;
    pregnancyDateType: string;
    pregnancyDelivery: string;
    injuryOrAccident: string;
    injuryOrAccidentDate: string;
    reasonForInjury: string;
    getPaperworkViaEmail: string;
    paperworkEmail: string;
    illnessDiagnosis: string;
    illnessSymptoms: string;
    isIllnessNew: boolean;
    illnessDate: string;
    timeAwayNeeded: string;
    continuousLastDayWorked: string;
    continuousFirstDayMissed: string;
    continuousFirstOfficeVisit: string;
    continuousLastOfficeVisit: string;
    continuousNextOfficeVisit: string;
    hasContinuousWorkReturnDate: string;
    continuousWorkReturnDateType: string;
    continuousWorkReturnDate: string;
    continuousHospitalizedStartDate: string;
    continuousHospitalizedEndDate: string;
    wasHospitalized: string;
    intermittentStartDate: string;
    intermittentEndDate: string;
    intermittentFrequency: string;
    reducedStartDate: string;
    reducedEndDate: string;
    reducedSchedule: string;
    providerName: string;
    providerPhone: string;
    providerFax: string;
    otherProviderName: string;
    otherProviderPhone: string;
    otherProviderFax: string;
    otherMedicalConditions: string;
    familyMemberRelationship: string;
    familyMemberDetails: string;
    familyMemberRelationshipOther: string;
    timeAwayNeededCommon: string;
    timeAwayStartDate: string;
    timeAwayEndDate: string;
    intermittentAnticipatedFrequency: string;
    reducedScheduleFrequency: string;
    jobTitle: string;
    timeAwayDateType: string;
    childBirthDate: string;
    childBirthTimeAwayNeeded: string;
    childBirthContinuousStartDate: string;
    childBirthContinuousEndDate: string;
    childBirthTimeAwayNeededOther: string;
    otherFosterCareReason: string;
    militaryMemberRelationship: string;
    militaryMemberDetails: string;
    militaryMemberStatus: string;
    adoptionReasons: string[];
    deployedForeignCountry: string;
    deployedRelationship: string;
    deploymentReasons: string[];
    hasAbsence: boolean;
    surgeryDetails: string;
    isEmployee: string;
    yourName: string;
    employeeRelation: string;
    employmentType: string;
    workSchedule: string;
    regularWorkDays: string;
    workState: string;
    stdEffectiveDate: string;
    ltdEffectiveDate: string;
    paidFrequency: string;
    paidType: string;
    compensationType: string;
    earnings: string;
    earningsType: string;
    lastDayHours: string;
    returnedToWork: string;
    returnedToWorkDate: string;
    returnedToWorkStatus: string;
}

export enum ClaimTypeEnum {
    ADD = "ADD",
    Life = "Life",
    LTD = "LTD",
    STD = "STD",
    Waiver = "Waiver",
    Unknown = "Unknown",
}

/** Represents a search for Claimant Policies. */
export interface ClaimantPoliciesRequest {
    /** The Date Of Birth. */
    dateOfBirth: string;
    /** The Last Four Ssn. */
    lastFourSsn: string;
}

/** Search request for scheduleA letter. */
export interface ClaimsListRequest {
    /** GroupId. */
    groupId: string | undefined;
    /** The page number indicator for pagination. */
    page: number;
    /** The size of each page. */
    pageSize: number;
    /** The direction to sort the search results by (Ascending or Descending). */
    sortDirection: SearchSortDirection;
    /** The field to sort the search results by. */
    sortField: SearchSortField;
}

/** Contract for Claim List. */
export interface ClaimsListResponse {
    /** Group Id associated with the Claim Loss Units. */
    groupId: string | undefined;
    /** Claim Loss Units associated with the Group Id. */
    claims: ClaimResponse[] | undefined;
    /** Results of current page. */
    currentPage: number;
    /** Total pages of results. */
    totalPages: number;
    /** Total number of results across all pages. */
    totalResults: number;
    /** Results per page. */
    resultsPerPage: number;
    /** The field to sort the search results by. */
    sortField: SearchSortField;
    /** The direction to sort the search results by (Ascending or Descending). */
    sortDirection: SearchSortDirection;
}

export interface Class {
    classCode: string;
    name: string;
    startDate: SymetraDateTime | undefined;
    stopDate: SymetraDateTime | undefined;
}

/** High-level information about a Claim Loss Unit response. */
export interface CluResponse {
    /** Claim Loss Unit name. */
    cluName: string | undefined;
    /** Claim Loss Unit number. */
    cluNumber: string | undefined;
    /** TThe policyId of Claim Loss Unit. */
    policyId: string | undefined;
}

/** Contract for Claim Loss Unit. */
export interface CluSearchResponse {
    /** Group Id associated with the Claim Loss Units. */
    groupId: string | undefined;
    /** Claim Loss Units associated with the Group Id. */
    claimLossUnits: CluResponse[] | undefined;
}

export enum ComponentsModelsImmutableDocumentsDocumentCategory {
    Unknown = "Unknown",
    All = "All",
    Correspondence = "Correspondence",
    Statements = "Statements",
    BillingStatements = "BillingStatements",
    RegularPremiumNotices = "RegularPremiumNotices",
    PastDuePremiumNotices = "PastDuePremiumNotices",
    InsufficientCviNotice = "InsufficientCviNotice",
    LoanInterestNotices = "LoanInterestNotices",
    LoanPremiumComboNotices = "LoanPremiumComboNotices",
    Policies = "Policies",
    Contracts = "Contracts",
    RenewalNotices = "RenewalNotices",
    IndexedAccountClosureNotice = "IndexedAccountClosureNotice",
    PremiumStatement = "PremiumStatement",
    SignedLeaveAgreement = "SignedLeaveAgreement",
    PlanDocument = "PlanDocument",
    Contract = "Contract",
    Certificate = "Certificate",
    AdministrativeAgreement = "AdministrativeAgreement",
    ERISA = "ERISA",
    BuyersGuides = "BuyersGuides",
}

/** Representation of a contact details. */
export interface ContactInfo {
    /** Account type of the policy. */
    accountType: string;
    /** Account Manager Name of the policy. */
    accountManagerName: string;
    /** Account Manager Email of the policy. */
    accountManagerEmail: string;
    /** Account Manager Phone of the policy. */
    accountManagerPhone: string;
}

export interface CoreComponent {
    description: string;
    id: string;
    planCode: string;
    policyElectableType: string;
    productComponentCode: string;
}

export interface Coverage {
    planName: string;
    planStatus: string;
    planDescription: string;
    policyNumber: string;
    policyId: string;
    coverageCode: string;
    productId: string;
    planId: string;
    coverageDesc: string;
    coverageLabel: string;
    coverageBucket: string;
    policyDocsTable: string;
    bucketCode: string;
    documentCategory: string;
    components: CoreComponent[] | undefined;
    classes: Class[] | undefined;
    benefitDefinition: BenefitDefinition | undefined;
    attributes: CoverageAttributes;
    coverageRateInfo: PlanRateInfo | undefined;
    startDate: SymetraDateTime | undefined;
    stopDate: SymetraDateTime | undefined;
}

export interface CoverageAttributes {
    acceleratedDeath: boolean;
    conversion: boolean;
    portability: boolean;
    waiverOfPremium: boolean;
}

/** Premium Coverage Info. */
export interface CoverageItemResponse {
    /** The  coverage code. */
    coverageCode: string | undefined;
    /** The  coverage type. */
    coverageType: string | undefined;
    /** The class number. */
    classNumber: string | undefined;
    /** The Rate info. */
    rateInfo: PlanRateInfo | undefined;
    /** The composite rates. */
    compositeRates: CoverageRateResponse | undefined;
    /** The bandedRates. */
    bandedRates: CoverageRateResponse[] | undefined;
}

/** Information about premium rate. */
export interface CoverageRateResponse {
    /** The  id. */
    id: string | undefined;
    /** The step band for the premium rate. */
    stepBand: string | undefined;
    /** Rate for the premium rate. */
    rate: number;
    /** Rate basis for the premium rate. */
    rateBasis: string | undefined;
    /** Rate to show in UI for the premium rate. */
    rateForUI: string | undefined;
    /** Head count for the premium rate. */
    headCount: number;
    /** Original units for previous period. */
    originalUnits: number;
    /** Volume for the premium rate. */
    volume: number;
    /** Original volume for previous period. */
    originalVolume: number;
    /** Premium for the premium rate. */
    premium: number;
    /** Premium 01 for current period. */
    premium01: number;
    /** Premium 02 for current period. */
    premium02: number;
    /** Original premium total for previous period. */
    totalOriginalPremium: number;
    /** Original premium 01 for previous period. */
    originalPremium01: number;
    /** Original premium 02 for previous period. */
    originalPremium02: number;
    /** Premium billId for previous period. */
    premiumBillId: string | undefined;
    /** Balance amount. */
    balanceAmount: number;
    /** Paid amount. */
    paidAmount: number;
    /** Current outstanding detailId. */
    currentOutstandingDetailId: string | undefined;
}

export interface CustomClaimsReportInfo {
    birthDate: string | undefined;
    name: string;
    claimNumber: string;
    status: string;
    classDescription: string;
    coverages: string;
    grossPayment: string;
    netPayment: string;
    paymentDate: string | undefined;
    paymentMethod: string;
    paymentStatus: string;
    payPeriodStartDate: string | undefined;
    payPeriodEndDate: string | undefined;
    taxes: string;
    receivedDate: string | undefined;
    receivedMinDate: string;
    receivedMaxDate: string;
    company: string;
    paymentType: string;
}

export interface CustomClaimsReportSelector {
    claimantName: boolean;
    claimantBirthDate: boolean;
    claimNumber: boolean;
    claimStatusAll: boolean;
    claimStatusOpen: boolean;
    claimStatusClosed: boolean;
    claimStatusPending: boolean;
    claimStatusIncomplete: boolean;
    paymentDetail: boolean;
    receivedStartDate: string;
    receivedEndDate: string;
    classDescription: boolean;
    coveragesAll: boolean;
    coveragesStd: boolean;
    coveragesLtd: boolean;
    coveragesAbsence: boolean;
    coveragesTermLife: boolean;
    coveragesWaiver: boolean;
    coveragesAccidentalDeath: boolean;
    company: string;
}

export interface CypressAccountRequest {
    emailId: string;
    tenantId: string;
    clientId: string;
    clientValue: string;
    refreshToken: string;
}

export interface CypressAccountResponse {
    tenantId: string | undefined;
    clientId: string | undefined;
    clientValue: string | undefined;
    tokenValue: string | undefined;
}

export interface DateRange {
    begin: SymetraDateTime | undefined;
    end: SymetraDateTime | undefined;
}

/** Demo User login request contract. */
export interface DemoTokenRequest {
    /** Demo name. */
    demoName: string | undefined;
    /** Demo Id. */
    demoId: string | undefined;
    /** Client Id. */
    clientId: string | undefined;
}

export interface Demographic {
    add1: string;
    add2: string;
    city: string;
    state: string;
    zip: string;
    eMail: string;
    phone: string;
}

export interface Dependent {
    isStudent: boolean;
    isDisabled: boolean;
    isTerminated: boolean;
    associatedWithActiveCoverage: boolean;
    memberId: string | undefined;
    fullName: string | undefined;
    firstName: string | undefined;
    middleName: string | undefined;
    lastName: string | undefined;
    suffix: string | undefined;
    birthDate: SymetraDateTime | undefined;
    age: string | undefined;
    ssn: string | undefined;
    maskedSSN: string | undefined;
    status: DependentStatus | undefined;
    gender: DependentGender | undefined;
    effDate: SymetraDateTime | undefined;
    termDate: SymetraDateTime | undefined;
    smokerStatus: DependentSmokerStatus | undefined;
    memberType: DependentMemberType | undefined;
    relationship: DependentRelationship | undefined;
    actionType: DependentActionType | undefined;
}

/** Contract for a single document's metadata from DocViewer. */
export interface DocumentInfoResponse {
    /** The document comment. */
    comment: string | undefined;
    /** The type of document comment. */
    commentType: string | undefined;
    /** The title the document belongs to. */
    documentTitle: string | undefined;
    /** The type of document. */
    documentType: string | undefined;
    /** Relative Uri for retrieving the file data. */
    fileUri: string | undefined;
    /** Policy Number associated with the document. */
    policyId: string | undefined;
    /** The date the document was created. */
    documentDate: string | undefined;
    /** The category the document belongs to. */
    documentCategory: DocumentInfoResponseDocumentCategory | undefined;
    /** The document file extension. */
    fileExtension: string | undefined;
    /** Flag to allow duplicates. */
    duplicate: boolean;
}

/** Represents a search for documents. */
export interface DocumentSearchRequest {
    /** The Policy Ids of document to return. */
    policyIds: string[] | undefined;
    /** The category of document to return. */
    documentCategory: DocumentSearchRequestDocumentCategory;
    /** The direction to sort the results in. */
    sortDirection: SearchSortDirection;
    /** The page of results to return. */
    page: number;
    /** The size of the page of results to return. */
    pageSize: number;
    /** The year of results to return. */
    year: string | undefined;
}

/** A matching page of search results, with metadata needed for pagination. */
export interface DocumentSearchResponse {
    /** The list of documents found in the search. */
    documents: DocumentInfoResponse[] | undefined;
    /** The number of results that were requested per page. */
    resultsPerPage: number;
    /** The total number of pages available. */
    totalPages: number;
    /** The total number of results. */
    totalResults: number;
}

export enum DocumentsContentType {
    Text = "Text",
    Json = "Json",
    Xml = "Xml",
    Pdf = "Pdf",
    FormUrlEncoded = "FormUrlEncoded",
    Jpeg = "Jpeg",
    Tiff = "Tiff",
    Bmp = "Bmp",
    Png = "Png",
    Html = "Html",
    WordDoc = "WordDoc",
    ExcelDoc = "ExcelDoc",
    Csv = "Csv",
    Gif = "Gif",
    OctetStreamPdf = "OctetStreamPdf",
    RichTextFormat = "RichTextFormat",
    OldExcelDoc = "OldExcelDoc",
    ExcelTemplate = "ExcelTemplate",
    ExcelDocWithMacros = "ExcelDocWithMacros",
    ExcelTemplateWithMacros = "ExcelTemplateWithMacros",
    ExcelAddinWithMacros = "ExcelAddinWithMacros",
    ExcelBinaryWithMacros = "ExcelBinaryWithMacros",
    OldPowerPoint = "OldPowerPoint",
    PowerPointDoc = "PowerPointDoc",
    PowerPointTemplate = "PowerPointTemplate",
    PowerPointSlideshow = "PowerPointSlideshow",
    PowerPointAddinWithMacros = "PowerPointAddinWithMacros",
    PowerPointFileWithMacros = "PowerPointFileWithMacros",
    PowerPointSlideshowWithMacros = "PowerPointSlideshowWithMacros",
    OldProject = "OldProject",
    OldVisio = "OldVisio",
    OldWord = "OldWord",
    WordTemplate = "WordTemplate",
    WordDocWithMacros = "WordDocWithMacros",
    WordTemplateWithMacros = "WordTemplateWithMacros",
    Framemaker = "Framemaker",
    MicrosoftDocumentImaging = "MicrosoftDocumentImaging",
}

/** Response of evidence of insurability details. */
export interface EOIApplicant {
    /** The policy Id of the eoi. */
    policyId: string | undefined;
    /** The employee Id of the eoi. */
    employeeId: string | undefined;
    /** The employee name of the eoi. */
    employeeName: string | undefined;
    /** The applicant name of the eoi. */
    applicantName: string | undefined;
    /** The coverage of the eoi. */
    coverage: string | undefined;
    /** The status of the eoi. */
    status: EOIApplicantStatus | undefined;
    /** The total amount of eoi. */
    amount: number;
    /** The submitted date. */
    submittedDate: string | undefined;
    /** The DecisionDate made date. */
    decisionDate: string | undefined;
    /** The Office location. */
    officeLocation: string | undefined;
    /** The source system. */
    sourceSystem: string | undefined;
}

/** Overview of significant dates on the policy, and other high-level policy information. */
export interface EOIApplicationsReponse {
    /** List of Applicants. */
    applicants: EOIApplicant[] | undefined;
    /** Results per page. */
    currentPage: number;
    /** Results per page. */
    resultsPerPage: number;
    /** The direction to sort the search results by (Ascending or Descending). */
    sortDirection: SearchSortDirection;
    /** The field to sort the search results by. */
    sortField: SearchSortField;
    /** Total pages of results. */
    totalPages: number;
    /** Total number of results across all pages. */
    totalResults: number;
}

/** Search request for policies. */
export interface EOIApplicationsRequest {
    /** Filter EOI Applications by the Applicant Name. */
    applicantName: string | undefined;
    /** Filter EOI Applications by the Decision From Date. */
    decisionFromDate: string | undefined;
    /** Filter EOI Applications by the Decision To Date. */
    decisionToDate: string | undefined;
    /** Filter EOI Applications by the Employee Name. */
    employeeName: string | undefined;
    /** The page number indicator for pagination. */
    page: number;
    /** The size of each page. */
    pageSize: number;
    /** Filter Policy ID. */
    policyId: string | undefined;
    /** Filter Policy IDs. */
    policyIds: string[] | undefined;
    /** The direction to sort the search results by (Ascending or Descending). */
    sortDirection: SearchSortDirection;
    /** The field to sort the search results by. */
    sortField: SearchSortField;
    /** Filter EOI Applications by the Status. */
    status: string[] | undefined;
    /** Filter EOI Applications by the Submitted From Date. */
    submittedFromDate: string | undefined;
    /** Filter EOI Applications by the Submitted To Date. */
    submittedToDate: string | undefined;
}

/** Eoi Statuses. */
export enum EoiStatus {
    Approved = "Approved",
    Declined = "Declined",
    Expired_application = "Expired application",
    Incomplete = "Incomplete",
    In_Process = "In Process",
    EOI_not_needed = "EOI not needed",
    Pending = "Pending",
    Returned_to_applicant = "Returned to applicant",
    Returned_to_policyholder = "Returned to policyholder",
    Unknown = "Unknown",
    Withdrew = "Withdrew",
}

export interface FlagsApiResponseOfBillingSearchResponse {
    flags: IFlag[];
    /** Contract for billings. */
    data: BillingSearchResponse | undefined;
    messages: LocalizedMessage[];
}

export interface FlagsApiResponseOfBoolean {
    flags: IFlag[];
    data: boolean;
    messages: LocalizedMessage[];
}

export interface FlagsApiResponseOfDocumentSearchResponse {
    flags: IFlag[];
    /** A matching page of search results, with metadata needed for pagination. */
    data: DocumentSearchResponse | undefined;
    messages: LocalizedMessage[];
}

export interface FlagsApiResponseOfNull {
    flags: IFlag[];
    data: Null | undefined;
    messages: LocalizedMessage[];
}

export interface FlagsApiResponseOfPolicyOverviewResponse {
    flags: IFlag[];
    /** Overview of significant dates on the policy, and other high-level policy information. */
    data: PolicyOverviewResponse | undefined;
    messages: LocalizedMessage[];
}

export interface FlagsApiResponseOfUserInfoResponse {
    flags: IFlag[];
    /** User information response contract. */
    data: UserInfoResponse | undefined;
    messages: LocalizedMessage[];
}

export interface FormAutosaveRecord {
    userId: string;
    formName: string;
    formId: string;
    formData: string;
    timestamp: number;
}

export interface FormAutosaveRequest {
    formName: string;
    formId: string;
    formData: string;
    timestamp: number;
}

/** Response of all forms details. */
export interface FormResponse {
    /** The Id of the form. */
    id: string | undefined;
    /** The form flag of the form. */
    formsFlag: FormsFlag;
    /** The name the form. */
    name: string | undefined;
    /** The English form number of the form. */
    englishFormNumber: string | undefined;
    /** The English Url of the form. */
    englishUrl: string | undefined;
    /** The Portability of the form. */
    portability: boolean;
    /** The Included Coverages of the form. */
    includedCoverages: string | undefined;
    /** The Included PlanCodes of the form. */
    includedPlanCodes: string | undefined;
    /** The Included States of the form. */
    includedStates: string | undefined;
    /** The Excluded States of the form. */
    excludedStates: string | undefined;
    /** The Accelerated Death of the form. */
    acceleratedDeath: boolean;
    /** The Waiver Of Premium of the form. */
    waiverOfPremium: boolean;
    /** The Conversion of the form. */
    conversion: boolean;
}

export enum FormsFlag {
    EmployeeForm = "EmployeeForm",
    ClaimsForm = "ClaimsForm",
    TaxForm = "TaxForm",
    CustomerForm = "CustomerForm",
}

export enum Gender {
    Female = "Female",
    Male = "Male",
    NonBinary = "Non-Binary",
    Unknown = "Unknown",
}

export interface GradedPlanClass {
    benefitPercent: string | undefined;
    code: string | undefined;
    duration: string | undefined;
    typeId: string | undefined;
    name: string | undefined;
    policyClassEntityId: string | undefined;
}

export interface GroupAddressResponse {
    address1: string | undefined;
    address2: string | undefined;
    address3: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zip: string | undefined;
}

export interface GroupContact {
    displayName: string;
    emails: string[];
    groupContactId: string;
    keyName: string;
    phones: string[];
    primaryContact: string;
}

export interface GroupContactResponse {
    groupContact: GroupContact[] | undefined;
}

/** Representation of a policy. */
export interface GroupPolicy {
    /** Policy number. */
    policyNumber: string | undefined;
    /** Policy Id. */
    policyId: string | undefined;
    /** The effective date of the policy. */
    effectiveDate: SymetraDateTime | undefined;
    /** The termination date of the policy. */
    terminationDate: SymetraDateTime | undefined;
    /** status of the policy. */
    status: string | undefined;
}

export enum HttpStatusCode {
    Continue = "Continue",
    SwitchingProtocols = "SwitchingProtocols",
    Processing = "Processing",
    EarlyHints = "EarlyHints",
    OK = "OK",
    Created = "Created",
    Accepted = "Accepted",
    NonAuthoritativeInformation = "NonAuthoritativeInformation",
    NoContent = "NoContent",
    ResetContent = "ResetContent",
    PartialContent = "PartialContent",
    MultiStatus = "MultiStatus",
    AlreadyReported = "AlreadyReported",
    IMUsed = "IMUsed",
    MultipleChoices = "MultipleChoices",
    MovedPermanently = "MovedPermanently",
    Found = "Found",
    SeeOther = "SeeOther",
    NotModified = "NotModified",
    UseProxy = "UseProxy",
    Unused = "Unused",
    RedirectKeepVerb = "RedirectKeepVerb",
    PermanentRedirect = "PermanentRedirect",
    BadRequest = "BadRequest",
    Unauthorized = "Unauthorized",
    PaymentRequired = "PaymentRequired",
    Forbidden = "Forbidden",
    NotFound = "NotFound",
    MethodNotAllowed = "MethodNotAllowed",
    NotAcceptable = "NotAcceptable",
    ProxyAuthenticationRequired = "ProxyAuthenticationRequired",
    RequestTimeout = "RequestTimeout",
    Conflict = "Conflict",
    Gone = "Gone",
    LengthRequired = "LengthRequired",
    PreconditionFailed = "PreconditionFailed",
    RequestEntityTooLarge = "RequestEntityTooLarge",
    RequestUriTooLong = "RequestUriTooLong",
    UnsupportedMediaType = "UnsupportedMediaType",
    RequestedRangeNotSatisfiable = "RequestedRangeNotSatisfiable",
    ExpectationFailed = "ExpectationFailed",
    MisdirectedRequest = "MisdirectedRequest",
    UnprocessableEntity = "UnprocessableEntity",
    Locked = "Locked",
    FailedDependency = "FailedDependency",
    UpgradeRequired = "UpgradeRequired",
    PreconditionRequired = "PreconditionRequired",
    TooManyRequests = "TooManyRequests",
    RequestHeaderFieldsTooLarge = "RequestHeaderFieldsTooLarge",
    UnavailableForLegalReasons = "UnavailableForLegalReasons",
    InternalServerError = "InternalServerError",
    NotImplemented = "NotImplemented",
    BadGateway = "BadGateway",
    ServiceUnavailable = "ServiceUnavailable",
    GatewayTimeout = "GatewayTimeout",
    HttpVersionNotSupported = "HttpVersionNotSupported",
    VariantAlsoNegotiates = "VariantAlsoNegotiates",
    InsufficientStorage = "InsufficientStorage",
    LoopDetected = "LoopDetected",
    NotExtended = "NotExtended",
    NetworkAuthenticationRequired = "NetworkAuthenticationRequired",
}

export interface IFlag {
    readonly name: string;
    readonly enabled: boolean;
}

export interface IMessageId {
    readonly value: string;
}

export interface IntermittentOccurrenceInfo {
    occurrenceID: string;
    startDate: string;
    endDate: string;
    status: string;
    hoursPending: string;
    hoursApproved: string;
    hoursDenied: string;
}

/** Invoice info for CyberSource. */
export interface InvoiceDetails {
    /** Invoice period. */
    period: BillingPeriod | undefined;
    /** Invoice number. */
    number: string;
    /** Invoice amount.  CANNOT be negative. */
    amount: number;
}

export interface InvoiceNotificationEmailServiceInput {
    requestorName: string | undefined;
    requestorEmail: string | undefined;
    transactionType: InvoiceNotificationEmailServiceInputTransactionType | undefined;
}

/** Line item info record class for CyberSource API. */
export interface LineItem {
    /** Symetra.Benefits.Api.Contracts.CyberSource.InvoiceDetails. */
    invoice: InvoiceDetails;
    /** Billing Group Name. */
    billingGroupName: string;
    /** Billing Group Number. */
    billingGroupNumber: string;
}

export interface LinkToPOBComponents {
    code: string | undefined;
    entityName: string | undefined;
    id: string | undefined;
    name: string | undefined;
}

export interface LocalizedMessage {
    body: string | undefined;
    id: IMessageId;
    severity: MessageSeverity;
    context: { [key: string]: any; };
}

export enum MaritalStatus {
    Single = "Single",
    Married = "Married",
    Unknown = "Unknown",
}

export interface MemberCoverage {
    policyId: string | undefined;
    policyStartDate: string | undefined;
    classId: string | undefined;
    classCode: string | undefined;
    productId: string | undefined;
    coverageCode: string | undefined;
    coverageName: string | undefined;
    planId: string | undefined;
    planName: string | undefined;
    coverageTier: string | undefined;
    billingCycleId: string | undefined;
    current: boolean;
    effectiveDate: string | undefined;
    terminationDate: string | undefined;
    benefitAmount: number;
    eoiAmount: number;
    guaranteedAmount: number;
    premiumTotal: number;
    requestedAmount: number;
    sortNames: string[] | undefined;
    policyDocsTable: string | undefined;
    bucketCode: string | undefined;
    coverageBucket: string | undefined;
    coverageLabel: string | undefined;
}

/** Response wrapper for Dependent objects */
export interface MemberDetailDependentResponse {
    memberId: string | undefined;
    fullName: string | undefined;
    firstName: string | undefined;
    middleName: string | undefined;
    lastName: string | undefined;
    suffix: string | undefined;
    dob: string | undefined;
    age: string | undefined;
    maskedSSN: string | undefined;
    status: MemberDetailDependentResponseStatus | undefined;
    gender: MemberDetailDependentResponseGender | undefined;
    effDate: string | undefined;
    termDate: string | undefined;
    smokerStatus: MemberDetailDependentResponseSmokerStatus | undefined;
    memberType: MemberDetailDependentResponseMemberType | undefined;
    relationship: MemberDetailDependentResponseRelationship | undefined;
    actionType: MemberDetailDependentResponseActionType | undefined;
    isStudent: boolean;
    isDisabled: boolean;
    isTerminated: boolean;
    associatedWithActiveCoverage: boolean;
}

/** Member detail response. */
export interface MemberDetailResponse {
    /** Member id. */
    memberId: string | undefined;
    /** Employee id. */
    employeeId: string | undefined;
    /** Employee id. */
    contractId: string | undefined;
    /** First name. */
    firstName: string | undefined;
    /** Last name. */
    lastName: string | undefined;
    /** Middle name. */
    middleName: string | undefined;
    /** Suffix. */
    suffix: string | undefined;
    /** Date of birth. */
    dob: string | undefined;
    /** Hire date. */
    hireDate: string | undefined;
    /** Address1. */
    address1: string | undefined;
    /** Address2. */
    address2: string | undefined;
    /** City. */
    city: string | undefined;
    /** State. */
    state: string | undefined;
    /** ZipCode. */
    zipCode: string | undefined;
    /** Email. */
    email: string | undefined;
    /** Date of birth. */
    gender: MemberDetailResponseGender | undefined;
    /** Member smoker status. */
    smokerStatus: MemberDetailResponseSmokerStatus | undefined;
    /** Member contract status. */
    contractStatus: MemberDetailResponseContractStatus | undefined;
    /** Member masked ssn. */
    maskedSsn: string | undefined;
    /** Job Site Code. */
    jobSiteCode: string | undefined;
    /** Coverage. */
    coverages: MemberCoverage[] | undefined;
    /** Occupation. */
    occupation: string | undefined;
    /** Bill division. */
    billDivision: string | undefined;
    /** Dependents. */
    dependents: MemberDetailDependentResponse[] | undefined;
    /** Salaries. */
    salaries: MemberSalary[] | undefined;
}

/** Member detail search request. */
export interface MemberDetailSearchRequest {
    /** Contract Id to search member detail. */
    contractId: string | undefined;
    /** Individual Id to search member detail. */
    individualId: string | undefined;
}

/** Contract for member detail response. */
export interface MemberDetailSearchResponse {
    /** Member detail response. */
    memberDetail: MemberDetailResponse | undefined;
}

export interface MemberIdsResponse {
    createIndividualsDemographics: string | undefined;
    createIndividualsMembercontracts: string | undefined;
    createIndividualsJobsites: string | undefined;
    createIndividualsSalaries: string | undefined;
    createMembercontractdetails: string | undefined;
    createIndividualsEmails: string | undefined;
}

/** Member response. */
export interface MemberInfoResponse {
    /** The applicant name. */
    applicantName: string | undefined;
    /** The billing code. */
    billingCode: string | undefined;
    /** The billing group. */
    billingDivision: string | undefined;
    /** The contract id. */
    contractId: string | undefined;
    /** The coverage. */
    coverage: string | undefined;
    /** The DOB. */
    dob: string | undefined;
    /** The employee id. */
    employeeId: string | undefined;
    /** The employee name. */
    employeeName: string | undefined;
    /** First name. */
    firstName: string | undefined;
    /** Last name. */
    lastName: string | undefined;
    /** Middle name. */
    middleName: string | undefined;
    /** The relationship. */
    relationship: MemberInfoResponseRelationship | undefined;
    /** The Status. */
    status: MemberInfoResponseStatus | undefined;
    /** Suffix. */
    suffix: string | undefined;
}

/** Member list. */
export interface MemberListResponse {
    /** Member list. */
    members: MemberInfoResponse[] | undefined;
    /** Policy id for the member list. */
    policyId: string | undefined;
}

/** Member list search request. */
export interface MemberListSearchRequest {
    /** Filter members by the billing division. */
    billingDivision: string | undefined;
    /** Filter members by the employee name. */
    employeeName: string | undefined;
    /** Group Id to search members. */
    groupId: string | undefined;
    /** The page number indicator for pagination. */
    page: number;
    /** The size of each page. */
    pageSize: number;
    /** Policy number to search members. */
    policyId: string | undefined;
    /** The direction to sort the search results by (Ascending or Descending). */
    sortDirection: SearchSortDirection;
    /** The field to sort the search results by. */
    sortField: SearchSortField;
    /** Filter members by the Status. */
    status: MemberListSearchRequestStatus | undefined;
}

/** Contract for member list. */
export interface MemberListSearchResponse {
    /** Member list response. */
    memberListResponse: MemberListResponse | undefined;
    /** Billings division. */
    billingDivisionList: string[];
    /** Results per page. */
    resultsPerPage: number;
    /** Current page. */
    currentPage: number;
    /** Total pages of results. */
    totalPages: number;
    /** Total number of results across all pages. */
    totalResults: number;
    /** The field to sort the search results by. */
    sortField: SearchSortField;
    /** The direction to sort the search results by (Ascending or Descending). */
    sortDirection: SearchSortDirection;
}

/** Request contract for member search. */
export interface MemberLookupSearchRequest {
    /** Term to search v3locity members for. */
    searchTerm: string | undefined;
    /** Offset for pagination. */
    offset: string | undefined;
    /** Limit for pagination. */
    limit: string | undefined;
}

export interface MemberResponse {
    responseIds: MemberIdsResponse | undefined;
    graphQLErrors: string[] | undefined;
    restErrors: string[] | undefined;
    statusCodes: HttpStatusCode[] | undefined;
}

export interface MemberSalary {
    annualSalary: number;
    endDate: string | undefined;
    salaryId: string | undefined;
    startDate: string | undefined;
}

export enum MemberSmokerStatus {
    NonSmoker = "NonSmoker",
    Smoker = "Smoker",
    Unknown = "Unknown",
}

export enum MemberStatus {
    Active = "Active",
    Calculated = "Calculated",
    Deceased = "Deceased",
    Draft = "Draft",
    Planned_termination = "Planned termination",
    Inactive = "Inactive",
    Invalid = "Invalid",
    Leave = "Leave",
    Pensing = "Pensing",
    Processed = "Processed",
    Retired = "Retired",
    Returned_to_Work = "Returned to Work",
    Terminated = "Terminated",
    Unknown = "Unknown",
}

export enum MemberType {
    Primary_Insured = "Primary Insured",
    Dependent = "Dependent",
    Primary_Beneficiary = "Primary Beneficiary",
    Contingent_Beneficiary = "Contingent Beneficiary",
    Unknown = "Unknown",
}

export enum MessageSeverity {
    Info = "Info",
    Warn = "Warn",
    Error = "Error",
}

export interface Null {
}

/** Payment request from UI. */
export interface PaymentRequest {
    currencyCode: string;
    totalAmount: number;
    groupName: string;
    groupNumber: string;
    acctType: string | undefined;
    acctNumber: string | undefined;
    routingNumber: string | undefined;
    lineItems: LineItem[] | undefined;
}

export interface PaymentResponse {
    groupId: string;
    cyberSourceId: string;
    paymentStatus: string;
    reconciliationId: string;
    transactionId: string;
    submitTimeUtc: string;
}

/** Representation of a payment details. */
export interface Payments {
    /** The policyId to search payment details against the policy. */
    policyId: string;
    /** Optional, Estimated payment amount due for policy. */
    estimatedPaymentAmountDue: number;
    /** Optional, Upcoming payment amount due for policy. */
    upcomingPaymentAmountDue: number;
    /** Due date of the policy. */
    dueDate: string;
    /** Optional, Last payment amount for Policy. */
    lastPaymentAmount: number;
    /** Optional, Policy last payment date. */
    lastPaymentDate: string;
    /** Optional, Policy billing method. */
    billingMethod: string;
}

export interface Person {
    employerBek: string | undefined;
    employerName: string | undefined;
    jobSiteId: string | undefined;
    jobSiteName: string | undefined;
    memberContractId: string | undefined;
    policyClassId: string | undefined;
    email: string | undefined;
    lastFourSsn: string | undefined;
    personBek: string | undefined;
    memberContractStatus: PersonMemberContractStatus | undefined;
    memberId: string | undefined;
    fullName: string | undefined;
    firstName: string | undefined;
    middleName: string | undefined;
    lastName: string | undefined;
    suffix: string | undefined;
    birthDate: SymetraDateTime | undefined;
    age: string | undefined;
    ssn: string | undefined;
    maskedSSN: string | undefined;
    status: PersonStatus | undefined;
    gender: PersonGender | undefined;
    effDate: SymetraDateTime | undefined;
    termDate: SymetraDateTime | undefined;
    smokerStatus: PersonSmokerStatus | undefined;
    memberType: PersonMemberType | undefined;
    relationship: PersonRelationship | undefined;
    actionType: PersonActionType | undefined;
}

export enum PersonRelationCode {
    Additional_Writing_Agent = "Additional Writing Agent",
    Annuitant = "Annuitant",
    Assignee = "Assignee",
    Beneficiary = "Beneficiary",
    Contingent_Annuitant = "Contingent Annuitant",
    Coverage_Insured = "Coverage Insured",
    Dependent = "Dependent",
    Insured = "Insured",
    Joint_Annuitant = "Joint Annuitant",
    Joint_insured = "Joint insured",
    Joint_owner = "Joint owner",
    Owner = "Owner",
    Payor = "Payor",
    Primary_Writing_Agent = "Primary Writing Agent",
    Servicing_Agent = "Servicing Agent",
    Spouse = "Spouse",
    Subordinate_Agent = "Subordinate Agent",
    Superior_Agent = "Superior Agent",
    Third_Party_Designee = "Third Party Designee",
}

export interface Plan {
    policyNumber: string | undefined;
    planCode: string | undefined;
    planName: string | undefined;
    planStatus: string | undefined;
    productCode: string | undefined;
    productName: string | undefined;
    coverageTiers: string[] | undefined;
    enrollmentEligibility: PlanEnrollmentEligibility | undefined;
    policyClasses: PlansPolicyClass[] | undefined;
    originalIssueDate: SymetraDateTime | undefined;
    defaultBillingCycleId: string | undefined;
    includeCarryOverFlag: boolean;
    planBenefit: PlanBenefitInfo | undefined;
    stateCode: string | undefined;
    startDate: SymetraDateTime | undefined;
    planRating: PlanRatingInfo | undefined;
    planEarnings: PlanEarningsInfo | undefined;
}

export interface PlanBenefitInfo {
    planBenefitDefnId: string | undefined;
    packageTypes: string | undefined;
    benefitPackages: BenefitPackageInfo[] | undefined;
    enrollmentElectionStyle: string | undefined;
    benefitDefinitionMultiple: string | undefined;
    roundingApplication: string | undefined;
    benefitElectionStyle: string | undefined;
    minimumStyle: string | undefined;
    roundingIncrement: string | undefined;
    roundingRule: string | undefined;
    flatAdjustmentStyle: string | undefined;
    maximumStyle: string | undefined;
    benefitDefn: string | undefined;
    flatAdjustmentAmt: string | undefined;
    earningsMultiples: string | undefined;
    earningMultipleRangeMin: string | undefined;
    earningMultipleRangeMax: string | undefined;
    flatAmounts: string | undefined;
    flatAmountRangeMaximum: string | undefined;
    rangeIncrement: string | undefined;
    maxEarningsMultiple: string | undefined;
    flatAmountRangeMinimum: string | undefined;
    benefitDefinitionPercent: string | undefined;
}

export interface PlanBenefitSalary {
    code: string | undefined;
    name: string | undefined;
}

export interface PlanEarningsInfo {
    earningMode: string | undefined;
    planBenefitSalaries: PlanBenefitSalary[] | undefined;
    id: string | undefined;
}

export interface PlanEnrollmentEligibility {
    waitingPeriodFrequency: string | undefined;
    allowLateEntrant: string | undefined;
    waitingPeriodDurationFactor: string | undefined;
    enrollmentWindowDays: number;
    applyMaxEnrolllmentAge: boolean;
    planEnrollmentEligibilityDefnId: string | undefined;
    effectiveDateFactorAddedDependents: string | undefined;
    effectiveDateFactor: string | undefined;
    effectiveDateFactorChangeEnrollment: string | undefined;
    useAgeOf: string | undefined;
    reducedServiceWaitingPeriodApplies: string | undefined;
}

export interface PlanRateInfo {
    rateExpressedPer: string;
    rateBasis: string;
    ratingStructure: string;
    ratingFrequency: string;
}

export interface PlanRatingClass {
    code: string | undefined;
    name: string | undefined;
    id: string | undefined;
}

export interface PlanRatingInfo {
    planRatingDefnId: string | undefined;
    rateExpressedPer: string | undefined;
    rateBasis: string | undefined;
    planRatingClasses: PlanRatingClass[] | undefined;
    ratingStructure: string | undefined;
    ratingFrequency: string | undefined;
    tobaccoStatus: string | undefined;
    genderFlag: string | undefined;
    premiumDimension: string | undefined;
    ratingAgeBasedOn: string | undefined;
}

/** Representation of Claim entity. */
export interface PlanYear {
    /** Gets or sets a value indicating whether the claim has absence claims. */
    name: string;
    /** Gets or sets a value indicating whether the claim has disability claims. */
    selected: boolean;
}

export interface PlansPolicyClass {
    policyClassCode: string | undefined;
    startDate: SymetraDateTime | undefined;
    policyClassName: string | undefined;
}

/** Information about policy billing. */
export interface PolicyBillingGroup {
    /** The Policy Id of billing. */
    groupId: string;
    /** The billing group name of billing. */
    billingGroupName: string;
    /** The billing group code of billing. */
    billingGroupCode: string;
    /** The admin style of billing. */
    adminStyle: string;
    /** The billing cycle id of billing. */
    billingCycleId: string;
    /** The current billing cycle detail Id of policy billing. */
    currentBillingCycleDetailId: string;
}

/** Representation of Claim entity. */
export interface PolicyClaimsFlagsResponse {
    /** Group Id. */
    groupId: string;
    /** Policy Number. */
    policyNumber: string;
    /** Gets or sets a value indicating whether the claim has absence claims. */
    hasAbsenceClaims: boolean;
    /** Gets or sets a value indicating whether the claim has disability claims. */
    hasDisabilityClaims: boolean;
    /** Gets or sets a value indicating whether the claim has life claims. */
    hasLifeClaims: boolean;
    /** Gets or sets a value indicating whether the claim has ASO claims. */
    hasASOClaims: boolean;
    /** Gets or sets a value indicating whether the claim has disability paid claims. */
    hasDisabilityPaidClaims: boolean;
    /** Gets or sets a value indicating whether the claim has PFL claims. */
    hasPFLClaims: boolean;
    /** Gets or sets a value indicating whether the claim has accommodation claims. */
    hasAccommodationClaims: boolean;
}

/** Representation of a policy class. */
export interface PolicyClass {
    /** Policy class id. */
    policyClassId: string | undefined;
    /** Policy class code. */
    policyClassCode: string | undefined;
    /** Policy class name. */
    policyClassName: string | undefined;
    /** The effective date of the class. */
    effectiveDate: string | undefined;
    /** The termination date of the class. */
    terminationDate: string | undefined;
    /** status of the class. */
    status: string | undefined;
}

/** Information about policy coverage. */
export interface PolicyCoverage {
    /** The Plan's name. */
    planName: string;
    /** The Plan's description. */
    planDescription: string;
    /** The Plan's status. */
    planStatus: string;
    /** The Policy number of coverage. */
    policyNumber: string;
    /** The Policy Id of coverage. */
    policyId: string;
    /** The coverage code of coverage. */
    coverageCode: string;
    /** The Product Id of coverage. */
    productId: string;
    /** The Plan Id of coverage. */
    planId: string;
    /** Description of coverage. */
    coverageDesc: string;
    /** Description of the coverage label. */
    coverageLabel: string;
    /** Description of the coverage bucket. */
    coverageBucket: string;
    /** Description of the coverage for docs table label. */
    policyDocsTable: string;
    /** Description of the bucket code. */
    bucketCode: string;
    /** Optional plan components. */
    components: CoreComponent[] | undefined;
    /** Classes this plan is in. */
    classes: Class[] | undefined;
    /** Benefit definition. */
    benefitDefinition: BenefitDefinition | undefined;
    /** Coverage attributes. */
    attributes: CoverageAttributes;
    /** Ratings of coverage. */
    coverageRateInfo: PlanRateInfo | undefined;
    /** Plan's start date. */
    startDate: SymetraDateTime | undefined;
    /** Plan's stop date. */
    stopDate: SymetraDateTime | undefined;
}

export interface PolicyCoverages {
    readonly coverages: Coverage[];
    readonly groupId: string;
}

/** Coverages associated with a given policy. */
export interface PolicyCoveragesResponse {
    /** Policy id for the policy. */
    policyCoverages: PolicyCoverages | undefined;
}

/** Representation of a policy details. */
export interface PolicyDetails {
    /** The policy name to hold the name. */
    policyHolder: string;
    /** Policy Id to identify the policy among policies. */
    policyId: string;
    /** Group Id. */
    groupId: string;
    /** Billing Entity Id. */
    billingEntityId: string;
    /** Group name. */
    groupName: string;
    /** The effective date of the policy. */
    effectiveDate: string;
    /** The next renewal of the policy. */
    nextRenewalDate: string;
    /** Status of the policy. */
    status: string;
    /** Situs State of the policy. */
    situsState: string;
    /** Anniversary date of the policy holder. */
    anniversaryDate: string;
}

/** Representation of a group offering. */
export interface PolicyOffering {
    /** Id of offering */
    offeringId: string | undefined;
    /** Policy code that this offer belongs to */
    policyCode: string | undefined;
    /** Offering version */
    offeringVersion: string | undefined;
    /** Offering generic status */
    offeringGenericStatusName: string | undefined;
    /** Is this offering current? */
    isCurrent: string | undefined;
    /** Offering as of date */
    asOfDate: SymetraDateTime | undefined;
    /** Offering time period, eg 1/1/25 - 6/1/25 */
    offeringPeriod: string | undefined;
    /** Offering's start date */
    startDate: SymetraDateTime | undefined;
    /** Offering's stop date */
    stopDate: SymetraDateTime | undefined;
    /** Offering's termination date */
    terminationDate: SymetraDateTime | undefined;
}

/** Overview of significant dates on the policy, and other high-level policy information. */
export interface PolicyOverviewResponse {
    /** Policy Details for the policy. */
    policyDetails: PolicyDetails | undefined;
    /** Policy Coverages for the policy. */
    policyCoverages: PolicyCoverage[] | undefined;
    /** Policy classes for the policy. */
    policyClasses: PolicyClass[] | undefined;
    /** Policy Billings for the policy. */
    policyBillings: PolicyBillingGroup[] | undefined;
    /** Group Policies for the policy. */
    groupPolicies: GroupPolicy[] | undefined;
    /** Policy Offerings for the policy. */
    policyOfferings: PolicyOffering[] | undefined;
    /** Contact information for the policy. */
    contactInfo: ContactInfo[] | undefined;
    /** Payment details for the policy. */
    payments: Payments | undefined;
    /** Lad policy. */
    isLad: boolean;
    /** SL policy. */
    isSL: boolean;
    /** The id of the group. */
    groupId: string | undefined;
    /** The group number of the group. */
    groupNumber: string | undefined;
    /** The policy ids. */
    policyIds: string[] | undefined;
    /** Policy token, used to access the policy. */
    policyToken: string | undefined;
}

/** Search request for policies. */
export interface PolicySearchRequest {
    /** The search category enum, such as "owner" or "policyId". */
    category: SearchCategory;
    /** The criteria to search for based on category. */
    criteria: string | undefined;
    /** The criteria to search for based on Group Name. */
    groupName: string | undefined;
    /** The criteria to search for based on  Group Number. */
    groupNumber: string | undefined;
    /** The page number indicator for pagination. */
    page: number;
    /** The size of each page. */
    pageSize: number;
    /** The direction to sort the search results by (Ascending or Descending). */
    sortDirection: SearchSortDirection;
    /** The field to sort the search results by. */
    sortField: SearchSortField;
}

/** A search result with partial policy information. */
export interface PolicySearchResultResponse {
    /** Employer Id. */
    employerId: string | undefined;
    /** Group number. */
    groupId: string | undefined;
    /** Group name. */
    groupName: string | undefined;
    /** Denotes the policy is in a suspended state. */
    isSuspended: boolean;
    /** The policyholder name. */
    policyholder: string | undefined;
    /** Policy number. */
    policyId: string | undefined;
    /** Policy token, used to access the policy. */
    policyToken: string | undefined;
    /** The relationship of the person on the policy. */
    relationship: PolicySearchResultResponseRelationship | undefined;
}

/** Response contract for the search endpoint. */
export interface PolicySearchResultsResponse {
    /** List of search results. */
    searchResults: PolicySearchResultResponse[] | undefined;
    /** Results of current page. */
    currentPage: number;
    /** Total pages of results. */
    totalPages: number;
    /** Total number of results across all pages. */
    totalResults: number;
    /** Results per page. */
    resultsPerPage: number;
    /** The field to sort the search results by. */
    sortField: SearchSortField;
    /** The direction to sort the search results by (Ascending or Descending). */
    sortDirection: SearchSortDirection;
}

export interface PolicyholderInfo {
    isAdmin: boolean;
    isClaim: boolean;
    clientIds: string[];
    hasEoi: boolean;
    groupId: string;
    displayName: string;
}

export enum PortalTransactionType {
    PremiumSubmit = "PremiumSubmit",
    Payment = "Payment",
    ScheduleA = "ScheduleA",
    InvoiceNotification = "InvoiceNotification",
}

/** Premium calculation Info. */
export interface PremiumCalculationInfoResponse {
    /** Group id for the premium calculation. */
    groupId: string;
    /** Policy id for the premium calculation. */
    policyId: string;
    /** Invoice number for the premium calculation. */
    invoiceNumber: string;
    /** Premium Id. */
    premiumId: string;
    /** Premium key. */
    premiumKey: string;
    /** Submitted by. */
    submittedBy: string;
    /** Submitted date. */
    submittedDate: string;
    /** SA comment. */
    saComment: string;
    /** Coverage items for the premium calculation. */
    coverageItems: CoverageItemResponse[] | undefined;
}

/** Premium calculation request. */
export interface PremiumCalculationSearchRequest {
    /** Group ID. */
    groupId: string;
    /** Premium ID. */
    premiumId: string;
    /** Premium key. */
    premiumKey: string;
    /** Invoice key. */
    invoiceKey: string;
    /** Invoice number. */
    invoiceNumber: string;
    /** Due Date key. */
    dueDateKey: string;
    /** Coverage Start Date. */
    coverageStartDate: string;
    /** Coverage Stop Date. */
    coverageStopDate: string;
}

/** Contract for premium. */
export interface PremiumCalculationSearchResponse {
    /** Premium calculation info for the invoice. */
    premiumCalculationInfo: PremiumCalculationInfoResponse | undefined;
}

/** Premium calculation update request. */
export interface PremiumCalculationSubmitRequest {
    /** Group id to update premium calculation. */
    groupId: string | undefined;
    /** Premium Id to update premium calculation. */
    premiumId: string | undefined;
    /** Premium key to update premium calculation. */
    premiumKey: string | undefined;
    /** The Group Name. */
    groupName: string | undefined;
    /** Group number. */
    groupNumber: string | undefined;
    /** Bill group name. */
    billGroupName: string | undefined;
    /** Bill group number. */
    billGroupNumber: string | undefined;
    /** Invoice period of updated premium calc.. */
    invoicePeriod: BillingPeriod;
    /** Invoice number. */
    invoiceNumber: string | undefined;
    /** Total amount of updated premium calculation. */
    totalAmount: number;
    /** Premium line items to be updated. */
    premiumItems: PremiumItemResponse[] | undefined;
}

export interface PremiumCalculatorInfo {
    groupId: string;
    premiumId: string;
    premiumDetailId: string;
    units: number;
    volume: number;
    premiumTotal: number;
    premium01: number;
    premium02: number;
}

export interface PremiumCalculatorRequest {
    groupId: string;
    premiumId: string;
    premiumDetailId: string;
    units: number;
    volume: number;
    premiumRate: number;
}

/** Premium line item info. */
export interface PremiumItemResponse {
    /** The premium line item Id. */
    id: string | undefined;
    /** The line item volume. */
    volume: number;
    /** The line item units. */
    units: number;
    /** Premium submit item premiumTotal. */
    premiumTotal: number;
    /** Premium submit item PremiumRate01. */
    premiumRate01: number;
    /** Premium submit item Premium01. */
    premium01: number;
    /** Premium submit item Premium02. */
    premium02: number;
    /** CoverageType. */
    coverageType: string | undefined;
    /** Class. */
    class: string | undefined;
    /** Premium Bill Id. */
    premiumBillId: string | undefined;
    /** Original volume for previous period. */
    originalVolume: number;
    /** Original units for previous period. */
    originalUnits: number;
    /** Original premium total for previous period. */
    totalOriginalPremium: number;
    /** Original premium 01 for previous period. */
    originalPremium01: number;
    /** Original premium 02 for previous period. */
    originalPremium02: number;
    /** Current outstanding detailId. */
    currentOutstandingDetailId: string | undefined;
}

export enum RelationType {
    Self = "Self",
    Spouse = "Spouse",
    Former_Spouse = "Former Spouse",
    Child = "Child",
    Other = "Other",
    Unknown = "Unknown",
}

export interface ScheduleAEmailServiceInput {
    policyId: string;
    policyName: string;
    requestorName: string | undefined;
    requestorUserName: string | undefined;
    requestorEmail: string | undefined;
    dateFrom: string;
    dateTo: string;
    transactionType: ScheduleAEmailServiceInputTransactionType | undefined;
}

/** High-level information about a scheduleA letter response. */
export interface ScheduleALetterResponse {
    /** Activity date of scheduleA letter. */
    activityDate: string | undefined;
    /** File id associated with the PDF document. */
    fileId: string | undefined;
    /** File uri associated with the PDF document. */
    fileUri: string | undefined;
    /** Mime Type with the PDF document. */
    mimeType: ScheduleALetterResponseMimeType | undefined;
    /** Plan's year of scheduleA letter. */
    planYear: string | undefined;
    /** The Policy Id of scheduleA letter. */
    policyId: string | undefined;
    /** Statement date of scheduleA letter. */
    statementDate: string | undefined;
}

/** Search request for scheduleA letter. */
export interface ScheduleALetterSearchRequest {
    /** The page number indicator for pagination. */
    page: number;
    /** The size of each page. */
    pageSize: number;
    /** Filter Policy ID. */
    policyId: string | undefined;
    /** Filter Policy IDs. */
    policyIds: string[] | undefined;
    /** The direction to sort the search results by (Ascending or Descending). */
    sortDirection: SearchSortDirection;
    /** The field to sort the search results by. */
    sortField: SearchSortField;
}

/** Erisa ScheduleA Letters response to UI. */
export interface ScheduleALetterSearchResponse {
    /** Results per page. */
    currentPage: number;
    /** List of scheduleA letters. */
    letters: ScheduleALetterResponse[] | undefined;
    /** Policy Number associated with the scheduleA letters. */
    policyId: string | undefined;
    /** Policy Numbers associated with the scheduleA letters. */
    policyIds: string[] | undefined;
    /** Results per page. */
    resultsPerPage: number;
    /** The direction to sort the search results by (Ascending or Descending). */
    sortDirection: SearchSortDirection;
    /** The field to sort the search results by. */
    sortField: SearchSortField;
    /** Total pages of results. */
    totalPages: number;
    /** Total number of results across all pages. */
    totalResults: number;
}

export enum SearchCategory {
    Unspecified = "Unspecified",
    Owner = "Owner",
    Insured = "Insured",
    GroupId = "GroupId",
    PolicyId = "PolicyId",
}

export interface SearchClaimData {
    claimNumber: string;
    claimTypes: ClaimTypeEnum[];
    dateReceived: SymetraDateTime | undefined;
    dateStarted: SymetraDateTime | undefined;
    divisionInfo: SearchClaimDivisionInfo;
    employee: SearchClaimEmployee;
    groupName: string | undefined;
    policyNumber: string | undefined;
    status: ClaimStatusEnum;
}

export interface SearchClaimDivisionInfo {
    divisionName: string;
}

export interface SearchClaimEmployee {
    firstName: string;
    lastName: string;
}

export interface SearchClaimEmployeeSearchCriteria {
    firstName: string | undefined;
    lastName: string | undefined;
}

export interface SearchClaimPaginationCriteria {
    hasNext: boolean;
    hasPrevious: boolean;
    pageNumber: number;
    pageSize: number;
    pageTotal: number;
}

export interface SearchClaimRequest {
    headerValue: string | undefined;
    paginationCriteria: SearchClaimPaginationCriteria | undefined;
    policyNumbers: string[];
    searchCriteria: SearchClaimSearchCriteria | undefined;
    sortCriteria: SearchClaimSortCriteria | undefined;
}

export interface SearchClaimResponse {
    data: SearchClaimData[] | undefined;
    totalCount: number;
    paginationCriteria: SearchClaimPaginationCriteria;
}

export interface SearchClaimSearchCriteria {
    claimNumber: string | undefined;
    claimStatus: string | undefined;
    claimTypes: ClaimTypeEnum[] | undefined;
    dateRangeReceived: DateRange | undefined;
    dateRangeStart: DateRange | undefined;
    divisionName: string | undefined;
    employee: SearchClaimEmployeeSearchCriteria | undefined;
    searchTerm: string | undefined;
}

export enum SearchClaimSortColumnEnum {
    ClaimNumber = "claimNumber",
    ClaimStatus = "claimStatus",
    ClaimType = "claimType",
    ReceivedDate = "receivedDate",
    StartDate = "startDate",
    DivisionName = "divisionName",
    FirstName = "firstName",
    LastName = "lastName",
}

export interface SearchClaimSortCriteria {
    sortDirection: SearchClaimSortDirectionEnum;
    sortColumn: SearchClaimSortColumnEnum;
}

export enum SearchClaimSortDirectionEnum {
    Asc = "asc",
    Desc = "desc",
}

export enum SearchSortDirection {
    Ascending = "Ascending",
    Descending = "Descending",
}

export enum SearchSortField {
    Unspecified = "Unspecified",
    Name = "Name",
    PolicyId = "PolicyId",
    Role = "Role",
    EmployeeName = "EmployeeName",
    ApplicantName = "ApplicantName",
    SubmittedFromDate = "SubmittedFromDate",
    SubmittedToDate = "SubmittedToDate",
    DecisionFromDate = "DecisionFromDate",
    DecisionToDate = "DecisionToDate",
    Status = "Status",
    RunDate = "RunDate",
    InvoiceNumber = "InvoiceNumber",
    BillGroupName = "BillGroupName",
    Invoice = "Invoice",
    BillGroup = "BillGroup",
    Amount = "Amount",
    Coverage = "Coverage",
    StatementDate = "StatementDate",
    BillingDivision = "BillingDivision",
    LastName = "LastName",
    FirstName = "FirstName",
    GroupName = "GroupName",
    GroupNumber = "GroupNumber",
    ClaimNumber = "ClaimNumber",
    Decision = "Decision",
}

export interface SymEmployeeInfo {
    isSuper: boolean;
    isClaims: boolean;
    isSubmit: boolean;
    isBasic: boolean;
}

export interface SymetraDateTime {
    readonly day: number;
    readonly dayOfWeek: SystemDayOfWeek;
    readonly month: number;
    unixMilliseconds: number;
    readonly year: number;
}

/** Representation of Contact. */
export interface SymetraEmployeeContactResponse {
    /** The user id of sym employee. */
    userName: string | undefined;
    /** The display name of sym employee. */
    displayName: string | undefined;
    /** The first name of sym employee. */
    firstName: string | undefined;
    /** The last name of sym employee. */
    lastName: string | undefined;
    /** The phone of sym employee. */
    phone: string | undefined;
    /** The email of sym employee. */
    email: string | undefined;
}

export enum SystemDayOfWeek {
    Sunday = "Sunday",
    Monday = "Monday",
    Tuesday = "Tuesday",
    Wednesday = "Wednesday",
    Thursday = "Thursday",
    Friday = "Friday",
    Saturday = "Saturday",
}

export interface TermConditionConsentInfo {
    termsConditionsAccepted: boolean;
    electronicConsentAccepted: boolean;
    hasRecords: boolean;
}

export interface TokenRequest {
    authorizationCode: string;
    clientId: string;
    redirectUrl: string;
}

/** Identity User Info request contract. */
export interface UserInfoRequest {
    /** The terms and conditions accepted. */
    termsConditionsAccepted: boolean;
    /** The electronic consent accepted. */
    electronicConsentAccepted: boolean;
}

/** User information response contract. */
export interface UserInfoResponse {
    /** Current user's email. */
    email: string | undefined;
    /** Current user's Given name. */
    firstName: string | undefined;
    /** Current user's full name. */
    fullName: string | undefined;
    /** Current user's Surname name. */
    lastName: string | undefined;
    /** Current user's phone number. */
    phoneNumber: string | undefined;
    /** User info. */
    policyholderInfo: PolicyholderInfo | undefined;
    /** User classification. */
    symClass: string | undefined;
    /** User info. */
    symEmployeeInfo: SymEmployeeInfo | undefined;
    /** User's id. */
    userId: string | undefined;
    /** Current user's user name. */
    userName: string | undefined;
    /** Current user's term, condition and consent info. */
    termConditionConsent: TermConditionConsentInfo | undefined;
}

export interface UserPreferenceRequest {
    invoiceNotification: boolean;
    groupNumber: string;
}

export interface UserPreferenceResponse {
    userId: string | undefined;
    invoiceNotification: string | undefined;
    groupNumber: string | undefined;
    userStdGuid: string | undefined;
}

export enum AddUpdateMemberRequestMaritalStatus {
    Single = "Single",
    Married = "Married",
    Unknown = "Unknown",
}

export enum AddUpdateMemberRequestStatus {
    Active = "Active",
    Calculated = "Calculated",
    Deceased = "Deceased",
    Draft = "Draft",
    Planned_termination = "Planned termination",
    Inactive = "Inactive",
    Invalid = "Invalid",
    Leave = "Leave",
    Pensing = "Pensing",
    Processed = "Processed",
    Retired = "Retired",
    Returned_to_Work = "Returned to Work",
    Terminated = "Terminated",
    Unknown = "Unknown",
}

export enum AddUpdateMemberRequestSmokerStatus {
    NonSmoker = "NonSmoker",
    Smoker = "Smoker",
    Unknown = "Unknown",
}

export enum AddUpdateMemberRequestGender {
    Female = "Female",
    Male = "Male",
    NonBinary = "Non-Binary",
    Unknown = "Unknown",
}

export enum AddUpdateMemberRequestMemberType {
    Primary_Insured = "Primary Insured",
    Dependent = "Dependent",
    Primary_Beneficiary = "Primary Beneficiary",
    Contingent_Beneficiary = "Contingent Beneficiary",
    Unknown = "Unknown",
}

export enum AddUpdateMemberRequestRelationship {
    Self = "Self",
    Spouse = "Spouse",
    Former_Spouse = "Former Spouse",
    Child = "Child",
    Other = "Other",
    Unknown = "Unknown",
}

export enum AddUpdateMemberRequestActionType {
    Add_Person = "Add Person",
    Update_Person = "Update Person",
    Add_Member = "Add Member",
    Update_Member = "Update Member",
    Terminate_Member = "Terminate Member",
    Add_Beneficiary = "Add Beneficiary",
    Update_Beneficiary = "Update Beneficiary",
    Terminate_Beneficiary = "Terminate Beneficiary",
    Add_Dependent = "Add Dependent",
    Update_Dependent = "Update Dependent",
    Terminate_Dependent = "Terminate Dependent",
    Add_Coverage = "Add Coverage",
    Update_Coverage = "Update Coverage",
    Terminate_Coverage = "Terminate Coverage",
    Unknown = "Unknown",
}

export enum BillingResponseExcelMimeType {
    Text = "Text",
    Json = "Json",
    Xml = "Xml",
    Pdf = "Pdf",
    FormUrlEncoded = "FormUrlEncoded",
    Jpeg = "Jpeg",
    Tiff = "Tiff",
    Bmp = "Bmp",
    Png = "Png",
    Html = "Html",
    WordDoc = "WordDoc",
    ExcelDoc = "ExcelDoc",
    Csv = "Csv",
    Gif = "Gif",
    OctetStreamPdf = "OctetStreamPdf",
    RichTextFormat = "RichTextFormat",
    OldExcelDoc = "OldExcelDoc",
    ExcelTemplate = "ExcelTemplate",
    ExcelDocWithMacros = "ExcelDocWithMacros",
    ExcelTemplateWithMacros = "ExcelTemplateWithMacros",
    ExcelAddinWithMacros = "ExcelAddinWithMacros",
    ExcelBinaryWithMacros = "ExcelBinaryWithMacros",
    OldPowerPoint = "OldPowerPoint",
    PowerPointDoc = "PowerPointDoc",
    PowerPointTemplate = "PowerPointTemplate",
    PowerPointSlideshow = "PowerPointSlideshow",
    PowerPointAddinWithMacros = "PowerPointAddinWithMacros",
    PowerPointFileWithMacros = "PowerPointFileWithMacros",
    PowerPointSlideshowWithMacros = "PowerPointSlideshowWithMacros",
    OldProject = "OldProject",
    OldVisio = "OldVisio",
    OldWord = "OldWord",
    WordTemplate = "WordTemplate",
    WordDocWithMacros = "WordDocWithMacros",
    WordTemplateWithMacros = "WordTemplateWithMacros",
    Framemaker = "Framemaker",
    MicrosoftDocumentImaging = "MicrosoftDocumentImaging",
}

export enum BillingResponseMimeType {
    Text = "Text",
    Json = "Json",
    Xml = "Xml",
    Pdf = "Pdf",
    FormUrlEncoded = "FormUrlEncoded",
    Jpeg = "Jpeg",
    Tiff = "Tiff",
    Bmp = "Bmp",
    Png = "Png",
    Html = "Html",
    WordDoc = "WordDoc",
    ExcelDoc = "ExcelDoc",
    Csv = "Csv",
    Gif = "Gif",
    OctetStreamPdf = "OctetStreamPdf",
    RichTextFormat = "RichTextFormat",
    OldExcelDoc = "OldExcelDoc",
    ExcelTemplate = "ExcelTemplate",
    ExcelDocWithMacros = "ExcelDocWithMacros",
    ExcelTemplateWithMacros = "ExcelTemplateWithMacros",
    ExcelAddinWithMacros = "ExcelAddinWithMacros",
    ExcelBinaryWithMacros = "ExcelBinaryWithMacros",
    OldPowerPoint = "OldPowerPoint",
    PowerPointDoc = "PowerPointDoc",
    PowerPointTemplate = "PowerPointTemplate",
    PowerPointSlideshow = "PowerPointSlideshow",
    PowerPointAddinWithMacros = "PowerPointAddinWithMacros",
    PowerPointFileWithMacros = "PowerPointFileWithMacros",
    PowerPointSlideshowWithMacros = "PowerPointSlideshowWithMacros",
    OldProject = "OldProject",
    OldVisio = "OldVisio",
    OldWord = "OldWord",
    WordTemplate = "WordTemplate",
    WordDocWithMacros = "WordDocWithMacros",
    WordTemplateWithMacros = "WordTemplateWithMacros",
    Framemaker = "Framemaker",
    MicrosoftDocumentImaging = "MicrosoftDocumentImaging",
}

export enum DependentStatus {
    Active = "Active",
    Calculated = "Calculated",
    Deceased = "Deceased",
    Draft = "Draft",
    Planned_termination = "Planned termination",
    Inactive = "Inactive",
    Invalid = "Invalid",
    Leave = "Leave",
    Pensing = "Pensing",
    Processed = "Processed",
    Retired = "Retired",
    Returned_to_Work = "Returned to Work",
    Terminated = "Terminated",
    Unknown = "Unknown",
}

export enum DependentGender {
    Female = "Female",
    Male = "Male",
    NonBinary = "Non-Binary",
    Unknown = "Unknown",
}

export enum DependentSmokerStatus {
    NonSmoker = "NonSmoker",
    Smoker = "Smoker",
    Unknown = "Unknown",
}

export enum DependentMemberType {
    Primary_Insured = "Primary Insured",
    Dependent = "Dependent",
    Primary_Beneficiary = "Primary Beneficiary",
    Contingent_Beneficiary = "Contingent Beneficiary",
    Unknown = "Unknown",
}

export enum DependentRelationship {
    Self = "Self",
    Spouse = "Spouse",
    Former_Spouse = "Former Spouse",
    Child = "Child",
    Other = "Other",
    Unknown = "Unknown",
}

export enum DependentActionType {
    Add_Person = "Add Person",
    Update_Person = "Update Person",
    Add_Member = "Add Member",
    Update_Member = "Update Member",
    Terminate_Member = "Terminate Member",
    Add_Beneficiary = "Add Beneficiary",
    Update_Beneficiary = "Update Beneficiary",
    Terminate_Beneficiary = "Terminate Beneficiary",
    Add_Dependent = "Add Dependent",
    Update_Dependent = "Update Dependent",
    Terminate_Dependent = "Terminate Dependent",
    Add_Coverage = "Add Coverage",
    Update_Coverage = "Update Coverage",
    Terminate_Coverage = "Terminate Coverage",
    Unknown = "Unknown",
}

export enum DocumentInfoResponseDocumentCategory {
    Absence = "Absence",
    All = "All",
    BillingStatements = "BillingStatements",
    Contracts = "Contracts",
    Correspondence = "Correspondence",
    InsufficientCviNotice = "InsufficientCviNotice",
    Life = "Life",
    LoanInterestNotices = "LoanInterestNotices",
    LoanPremiumComboNotices = "LoanPremiumComboNotices",
    LTD = "LTD",
    NCE = "NCE",
    Notice = "Notice",
    NYPFL = "NYPFL",
    PastDuePremiumNotices = "PastDuePremiumNotices",
    PFML = "PFML",
    Policies = "Policies",
    RegularPremiumNotices = "RegularPremiumNotices",
    RenewalNotices = "RenewalNotices",
    SB = "SB",
    SBCert = "SBCert",
    SL = "SL",
    Statements = "Statements",
    STD = "STD",
    Unknown = "Unknown",
}

export enum DocumentSearchRequestDocumentCategory {
    Unknown = "Unknown",
    All = "All",
    Correspondence = "Correspondence",
    Statements = "Statements",
    BillingStatements = "BillingStatements",
    RegularPremiumNotices = "RegularPremiumNotices",
    PastDuePremiumNotices = "PastDuePremiumNotices",
    InsufficientCviNotice = "InsufficientCviNotice",
    LoanInterestNotices = "LoanInterestNotices",
    LoanPremiumComboNotices = "LoanPremiumComboNotices",
    Policies = "Policies",
    Contracts = "Contracts",
    RenewalNotices = "RenewalNotices",
    IndexedAccountClosureNotice = "IndexedAccountClosureNotice",
    PremiumStatement = "PremiumStatement",
    SignedLeaveAgreement = "SignedLeaveAgreement",
    PlanDocument = "PlanDocument",
    Contract = "Contract",
    Certificate = "Certificate",
    AdministrativeAgreement = "AdministrativeAgreement",
    ERISA = "ERISA",
    BuyersGuides = "BuyersGuides",
}

export enum EOIApplicantStatus {
    Approved = "Approved",
    Declined = "Declined",
    Expired_application = "Expired application",
    Incomplete = "Incomplete",
    In_Process = "In Process",
    EOI_not_needed = "EOI not needed",
    Pending = "Pending",
    Returned_to_applicant = "Returned to applicant",
    Returned_to_policyholder = "Returned to policyholder",
    Unknown = "Unknown",
    Withdrew = "Withdrew",
}

export enum InvoiceNotificationEmailServiceInputTransactionType {
    PremiumSubmit = "PremiumSubmit",
    Payment = "Payment",
    ScheduleA = "ScheduleA",
    InvoiceNotification = "InvoiceNotification",
}

export enum MemberDetailDependentResponseStatus {
    Active = "Active",
    Calculated = "Calculated",
    Deceased = "Deceased",
    Draft = "Draft",
    Planned_termination = "Planned termination",
    Inactive = "Inactive",
    Invalid = "Invalid",
    Leave = "Leave",
    Pensing = "Pensing",
    Processed = "Processed",
    Retired = "Retired",
    Returned_to_Work = "Returned to Work",
    Terminated = "Terminated",
    Unknown = "Unknown",
}

export enum MemberDetailDependentResponseGender {
    Female = "Female",
    Male = "Male",
    NonBinary = "Non-Binary",
    Unknown = "Unknown",
}

export enum MemberDetailDependentResponseSmokerStatus {
    NonSmoker = "NonSmoker",
    Smoker = "Smoker",
    Unknown = "Unknown",
}

export enum MemberDetailDependentResponseMemberType {
    Primary_Insured = "Primary Insured",
    Dependent = "Dependent",
    Primary_Beneficiary = "Primary Beneficiary",
    Contingent_Beneficiary = "Contingent Beneficiary",
    Unknown = "Unknown",
}

export enum MemberDetailDependentResponseRelationship {
    Self = "Self",
    Spouse = "Spouse",
    Former_Spouse = "Former Spouse",
    Child = "Child",
    Other = "Other",
    Unknown = "Unknown",
}

export enum MemberDetailDependentResponseActionType {
    Add_Person = "Add Person",
    Update_Person = "Update Person",
    Add_Member = "Add Member",
    Update_Member = "Update Member",
    Terminate_Member = "Terminate Member",
    Add_Beneficiary = "Add Beneficiary",
    Update_Beneficiary = "Update Beneficiary",
    Terminate_Beneficiary = "Terminate Beneficiary",
    Add_Dependent = "Add Dependent",
    Update_Dependent = "Update Dependent",
    Terminate_Dependent = "Terminate Dependent",
    Add_Coverage = "Add Coverage",
    Update_Coverage = "Update Coverage",
    Terminate_Coverage = "Terminate Coverage",
    Unknown = "Unknown",
}

export enum MemberDetailResponseGender {
    Female = "Female",
    Male = "Male",
    NonBinary = "Non-Binary",
    Unknown = "Unknown",
}

export enum MemberDetailResponseSmokerStatus {
    NonSmoker = "NonSmoker",
    Smoker = "Smoker",
    Unknown = "Unknown",
}

export enum MemberDetailResponseContractStatus {
    Active = "Active",
    Calculated = "Calculated",
    Deceased = "Deceased",
    Draft = "Draft",
    Planned_termination = "Planned termination",
    Inactive = "Inactive",
    Invalid = "Invalid",
    Leave = "Leave",
    Pensing = "Pensing",
    Processed = "Processed",
    Retired = "Retired",
    Returned_to_Work = "Returned to Work",
    Terminated = "Terminated",
    Unknown = "Unknown",
}

export enum MemberInfoResponseRelationship {
    Self = "Self",
    Spouse = "Spouse",
    Former_Spouse = "Former Spouse",
    Child = "Child",
    Other = "Other",
    Unknown = "Unknown",
}

export enum MemberInfoResponseStatus {
    Active = "Active",
    Calculated = "Calculated",
    Deceased = "Deceased",
    Draft = "Draft",
    Planned_termination = "Planned termination",
    Inactive = "Inactive",
    Invalid = "Invalid",
    Leave = "Leave",
    Pensing = "Pensing",
    Processed = "Processed",
    Retired = "Retired",
    Returned_to_Work = "Returned to Work",
    Terminated = "Terminated",
    Unknown = "Unknown",
}

export enum MemberListSearchRequestStatus {
    Active = "Active",
    Calculated = "Calculated",
    Deceased = "Deceased",
    Draft = "Draft",
    Planned_termination = "Planned termination",
    Inactive = "Inactive",
    Invalid = "Invalid",
    Leave = "Leave",
    Pensing = "Pensing",
    Processed = "Processed",
    Retired = "Retired",
    Returned_to_Work = "Returned to Work",
    Terminated = "Terminated",
    Unknown = "Unknown",
}

export enum PersonMemberContractStatus {
    Active = "Active",
    Calculated = "Calculated",
    Deceased = "Deceased",
    Draft = "Draft",
    Planned_termination = "Planned termination",
    Inactive = "Inactive",
    Invalid = "Invalid",
    Leave = "Leave",
    Pensing = "Pensing",
    Processed = "Processed",
    Retired = "Retired",
    Returned_to_Work = "Returned to Work",
    Terminated = "Terminated",
    Unknown = "Unknown",
}

export enum PersonStatus {
    Active = "Active",
    Calculated = "Calculated",
    Deceased = "Deceased",
    Draft = "Draft",
    Planned_termination = "Planned termination",
    Inactive = "Inactive",
    Invalid = "Invalid",
    Leave = "Leave",
    Pensing = "Pensing",
    Processed = "Processed",
    Retired = "Retired",
    Returned_to_Work = "Returned to Work",
    Terminated = "Terminated",
    Unknown = "Unknown",
}

export enum PersonGender {
    Female = "Female",
    Male = "Male",
    NonBinary = "Non-Binary",
    Unknown = "Unknown",
}

export enum PersonSmokerStatus {
    NonSmoker = "NonSmoker",
    Smoker = "Smoker",
    Unknown = "Unknown",
}

export enum PersonMemberType {
    Primary_Insured = "Primary Insured",
    Dependent = "Dependent",
    Primary_Beneficiary = "Primary Beneficiary",
    Contingent_Beneficiary = "Contingent Beneficiary",
    Unknown = "Unknown",
}

export enum PersonRelationship {
    Self = "Self",
    Spouse = "Spouse",
    Former_Spouse = "Former Spouse",
    Child = "Child",
    Other = "Other",
    Unknown = "Unknown",
}

export enum PersonActionType {
    Add_Person = "Add Person",
    Update_Person = "Update Person",
    Add_Member = "Add Member",
    Update_Member = "Update Member",
    Terminate_Member = "Terminate Member",
    Add_Beneficiary = "Add Beneficiary",
    Update_Beneficiary = "Update Beneficiary",
    Terminate_Beneficiary = "Terminate Beneficiary",
    Add_Dependent = "Add Dependent",
    Update_Dependent = "Update Dependent",
    Terminate_Dependent = "Terminate Dependent",
    Add_Coverage = "Add Coverage",
    Update_Coverage = "Update Coverage",
    Terminate_Coverage = "Terminate Coverage",
    Unknown = "Unknown",
}

export enum PolicySearchResultResponseRelationship {
    Additional_Writing_Agent = "Additional Writing Agent",
    Annuitant = "Annuitant",
    Assignee = "Assignee",
    Beneficiary = "Beneficiary",
    Contingent_Annuitant = "Contingent Annuitant",
    Coverage_Insured = "Coverage Insured",
    Dependent = "Dependent",
    Insured = "Insured",
    Joint_Annuitant = "Joint Annuitant",
    Joint_insured = "Joint insured",
    Joint_owner = "Joint owner",
    Owner = "Owner",
    Payor = "Payor",
    Primary_Writing_Agent = "Primary Writing Agent",
    Servicing_Agent = "Servicing Agent",
    Spouse = "Spouse",
    Subordinate_Agent = "Subordinate Agent",
    Superior_Agent = "Superior Agent",
    Third_Party_Designee = "Third Party Designee",
}

export enum ScheduleAEmailServiceInputTransactionType {
    PremiumSubmit = "PremiumSubmit",
    Payment = "Payment",
    ScheduleA = "ScheduleA",
    InvoiceNotification = "InvoiceNotification",
}

export enum ScheduleALetterResponseMimeType {
    Text = "Text",
    Json = "Json",
    Xml = "Xml",
    Pdf = "Pdf",
    FormUrlEncoded = "FormUrlEncoded",
    Jpeg = "Jpeg",
    Tiff = "Tiff",
    Bmp = "Bmp",
    Png = "Png",
    Html = "Html",
    WordDoc = "WordDoc",
    ExcelDoc = "ExcelDoc",
    Csv = "Csv",
    Gif = "Gif",
    OctetStreamPdf = "OctetStreamPdf",
    RichTextFormat = "RichTextFormat",
    OldExcelDoc = "OldExcelDoc",
    ExcelTemplate = "ExcelTemplate",
    ExcelDocWithMacros = "ExcelDocWithMacros",
    ExcelTemplateWithMacros = "ExcelTemplateWithMacros",
    ExcelAddinWithMacros = "ExcelAddinWithMacros",
    ExcelBinaryWithMacros = "ExcelBinaryWithMacros",
    OldPowerPoint = "OldPowerPoint",
    PowerPointDoc = "PowerPointDoc",
    PowerPointTemplate = "PowerPointTemplate",
    PowerPointSlideshow = "PowerPointSlideshow",
    PowerPointAddinWithMacros = "PowerPointAddinWithMacros",
    PowerPointFileWithMacros = "PowerPointFileWithMacros",
    PowerPointSlideshowWithMacros = "PowerPointSlideshowWithMacros",
    OldProject = "OldProject",
    OldVisio = "OldVisio",
    OldWord = "OldWord",
    WordTemplate = "WordTemplate",
    WordDocWithMacros = "WordDocWithMacros",
    WordTemplateWithMacros = "WordTemplateWithMacros",
    Framemaker = "Framemaker",
    MicrosoftDocumentImaging = "MicrosoftDocumentImaging",
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}

// :  Do NOT delete this file!  It is required for the 'nswag' utility to work properly.
// :  This file is used to extend the generated client with custom code.

/* istanbul ignore file */

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
// eslint-disable-next-line @typescript-eslint/no-unused-vars